/**
 * @file edm-bundle-builder-bb.js
 * @deprecated This file has been FULLY migrated to the modular structure.
 * 
 * Migration Status: ✅ 100% COMPLETE
 * 
 * ALL FUNCTIONS HAVE BEEN MIGRATED:
 * 
 * === GLOBAL FUNCTIONS (Landing Pages) ===
 * - initGlobalBottomSheet() → Controller._initGlobalBottomSheet()
 * - initDesktopModal() → Controller._initDesktopModal()
 * - initGlobalModal() → Controller._initGlobalModal()
 * - initGlobalBundleBuilder() → Controller._setupGlobalEventDelegation()
 * - handleGlobalTrigger() → Controller._handleGlobalTrigger()
 * - handleLegacyTrigger() → Controller._handleLegacyTrigger()
 * - loadProductForModal() → Controller._loadProductForModal()
 * - attachOneClickHandlers() → Controller._attachOneClickHandlers()
 * - loadProductAndOpenSheet() → Controller._initGlobalBottomSheet() (internal)
 * - populateSheetWithProduct() → Controller._initGlobalBottomSheet() (internal)
 * - window.openGlobalBottomSheet → Fallback-IIFE in edm-bundle-controller.js
 * - window.openDesktopModal → Fallback-IIFE in edm-bundle-controller.js
 * - Fallback-Funktionen (IIFE) → Fallback-IIFE in edm-bundle-controller.js
 * 
 * === PDP FUNCTIONS ===
 * - BottomSheetController → Controller.initPDP()
 * - All PDP functions → Controller.initPDP() + private methods
 * - All Mobile functions → Controller.initPDP() + UIRenderMobile
 * - All Desktop functions → Controller._setupDesktopInteractions() + UIRenderDesktop
 * - All API functions → API.*
 * - All State functions → State.*
 * 
 * This file is kept for reference only and should NOT be used in production.
 * All functionality has been migrated to:
 * - edm-bundle-controller.js (orchestration)
 * - edm-bundle-api.js (API communication)
 * - edm-bundle-state.js (state management)
 * - edm-bundle-ui-render-desktop.js (desktop rendering)
 * - edm-bundle-ui-render-mobile.js (mobile rendering)
 * - edm-bundle-ui-interactions.js (event handlers)
 * - edm-bundle-utils.js (utilities)
 * - edm-bundle-analytics.js (analytics)
 * - edm-bundle-config.js (configuration)
 */

// assets/edm-bundle-builder-bb.js

(() => {
    const onReady = (fn) => (document.readyState === 'loading')
      ? document.addEventListener('DOMContentLoaded', fn, { once: true })
      : fn();
  
    onReady(() => {
      // ===== PDP-Version (mit #bundle-builder Element) =====
      const el = document.getElementById('bundle-builder');
  
  
    // Markiere: BB aktiv -> schaltet Sticky Buy-Me global ab (CSS) und verhindert dessen Boot
    document.documentElement.classList.add('has-bundle-builder');
    // Hard override: prevent Sticky Buy-Me from booting and ensure it's hidden if present
    try {
      window.__stickyBuymeBooted = true;
      const sb = document.getElementById('sticky-buyme');
      if (sb) { sb.setAttribute('hidden',''); sb.setAttribute('aria-hidden','true'); sb.style.display = 'none'; }
    } catch(e){}
  
      if (!el) return;
      if (el.dataset.bbInit === '1') return;
      el.dataset.bbInit = '1';
      document.documentElement.classList.add('has-bundle-builder'); // Buy-Me überall ersetzen
  
  
      /* ================== SHARED HELPERS ================== */
  
      // === ATC Spinner (Dawn-kompatibel) ===
      function findATC(root){
        const scope = root || document;
        const forms = Array.from(scope.querySelectorAll('form[action^="/cart/add"]'));
        for (const f of forms){
          const btn = f.querySelector('button[name="add"], [type="submit"]');
          if (btn) return btn;
        }
        return null;
      }
  
      function bbToggleATCSpinner(isLoading){
        const btn = findATC();
        if (!btn) return;
  
        const host = btn.closest('product-form') || btn.parentElement || document;
        let spinner = host.querySelector('.loading-overlay__spinner');
        if (!spinner){
          spinner = document.createElement('span');
          spinner.className = 'loading-overlay__spinner hidden';
          spinner.setAttribute('aria-hidden','true');
          host.appendChild(spinner);
        }
  
        btn.classList.toggle('loading', !!isLoading);
        btn.setAttribute('aria-disabled', isLoading ? 'true' : 'false');
        spinner.classList.toggle('hidden', !isLoading);
      }
  
  
      const safeParseJSON = (s, fb) => { try { return JSON.parse(s); } catch(e){ return fb; } };
      const fmtMoney = (cents, format) => {
        if (window.Shopify && typeof Shopify.formatMoney === 'function') {
          try { return Shopify.formatMoney(cents, format || '{{ amount }}'); } catch(e){}
        }
        const value = (cents / 100).toFixed(2).replace('.', ',');
        return (format || '€{{amount}}').replace(/\{\{\s*amount\s*\}\}/, value);
      };
  
      // --- Analytics helper: GA4 (gtag) + GTM (dataLayer) falls vorhanden ---
      // Context7: Performance - Analytics never block main thread
      function bbTrack(name, params = {}) {
        const sendEvent = () => {
          // GTM
          if (window.dataLayer && typeof window.dataLayer.push === 'function') {
            window.dataLayer.push({ event: `bb_${name}`, ...params });
          }
          // GA4 gtag.js
          if (typeof window.gtag === 'function') {
            window.gtag('event', `bb_${name}`, params);
          }
        };
        
        // Use requestIdleCallback if available to avoid blocking main thread
        if ('requestIdleCallback' in window) {
          requestIdleCallback(sendEvent, { timeout: 2000 });
        } else {
          // Fallback: Use setTimeout with 0 delay for non-critical browsers
          setTimeout(sendEvent, 0);
        }
      }
  
  
      const mqMobile = window.matchMedia('(max-width: 989px)');
      const isMobile = () => mqMobile.matches;
  
      // PDP-CTAs im Mobile sauber ausblenden, nur für Seiten mit Bundle-Builder
      if (isMobile()) document.body.classList.add('bb--mobile-active');
  
      const handleMobileChange = (e) => {
        // Body-Klasse umschalten
        if (e.matches) document.body.classList.add('bb--mobile-active');
        else document.body.classList.remove('bb--mobile-active');
  
        // Bei Eintritt ins Mobile-Layout mobile UI frisch aufbauen
        if (e.matches) {
          mobile_buildTicks();
          mobile_applySlotNumbers();
          mobile_updateSticky();
          mobile_gateSticky();
          mobile_fixSlotAria();
        } else {
          // (Optional) Beim Verlassen Mobile aufräumen:
          // sheet/sticky verbergen o.ä., falls nötig
          const stickyEl = document.getElementById('bb-sticky');
          stickyEl?.classList.remove('is-visible');
        }
      };
      if (mqMobile.addEventListener) mqMobile.addEventListener('change', handleMobileChange);
      else if (mqMobile.addListener) mqMobile.addListener(handleMobileChange); // Safari-Fallback
  
  
      // === Cart sections once-per-sync ===
      const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const RENDER_SECTIONS = (cartEl?.getSectionsToRender?.() || []).map(s => s.section || s.id);
  
      // === Drawer-Intent / User-close guard ===
      let __bb_userClosedDuringSync = false;
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        const mo = new MutationObserver(() => {
          if (__bb_syncing && !drawer.hasAttribute('open')) __bb_userClosedDuringSync = true;
        });
        mo.observe(drawer, { attributes:true, attributeFilter:['open'] });
      }
  
      /* ================== DATA & STATE ================== */
      // --- Cart open behavior (configurable) ---
      const openCartAfterAdd = el.dataset.openCartAfterAdd === 'true';
      const FAST_OPEN_MS = 350; // if sync schneller als diese Schwelle: Drawer sofort öffnen

      // Unterscheidung Bundle-Typ (Booster vs. Smart Set)
      const bundleType = el.dataset.bundleType || 'booster'; // 'booster' | 'smart_set'
      const isSmartSet = bundleType === 'smart_set';

      // Smart Sets haben keine dynamischen Tiers
      let tiersRaw = safeParseJSON(el.dataset.tiers, [{qty:3,off:10},{qty:7,off:20},{qty:10,off:25}]) || [];
      if (isSmartSet) tiersRaw = []; 
      const tiers = tiersRaw.slice().sort((a,b)=>a.qty-b.qty);

      const maxSlots   = parseInt(el.dataset.maxSlots || '10', 10);
      const unitPrice  = parseInt(el.dataset.unitPrice, 10) || 0;

      const moneyFormat= safeParseJSON(el.dataset.moneyFormat || '"${{amount}}"', "${{amount}}");
      const productId  = Number(el.dataset.productId);
  
      const state = {
        items: {}, // {variantId: qty}
        get totalQty(){ return Object.values(this.items).reduce((a,b)=>a+b,0); },
        get tier(){ let t=null; for (const ti of tiers) if (this.totalQty>=ti.qty) t=ti; return t; }
      };
  
      el.dataset.activeBundleKey = '';
      el.dataset.cartDirty = '0';
  
  // ---------------- CART I/O HELPERS (sauber, ohne __v-Checks) ----------------
  
  // === bundled cart.update helper ===
  // Context7: Return both response and data to enable sections collection
  async function cartUpdateWithSections(updates){
    const payload = { updates };
    const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const RENDER_SECTIONS = (cartEl?.getSectionsToRender?.() || []).map(s => s.section || s.id);
    if (Array.isArray(RENDER_SECTIONS) && RENDER_SECTIONS.length){
      payload.sections = RENDER_SECTIONS;
      payload.sections_url = window.location.pathname; // wichtig: muss mit "/" starten
    }
    const res = await fetch('/cart/update.js', {
      method:'POST',
      headers:{
        'Content-Type':'application/json',
        'X-Requested-With':'XMLHttpRequest',
        'Accept':'application/json'
      },
      credentials:'same-origin',
      body: JSON.stringify(payload)
    });
    const data = await res.json();
    return { res, data }; // Return both response and data
  }
  
    // === CART CACHE (Context7: Single Source of Truth) ===
    // Context7: Cache cart result within a sync cycle to reduce redundant fetchCart calls
    let __bb_cartCache = null;
    async function getCartCached() {
      if (!__bb_cartCache) __bb_cartCache = await fetchCart();
      return __bb_cartCache;
    }
  
    async function fetchCart(){
      const res = await fetch('/cart.js', { headers: { 'Accept':'application/json' }});
      return res.json();
    }
  
    // Context7: Single Source of Truth - Centralized maximum capping logic
    function capToMaximum(items, maxSlots) {
      const totalQty = Object.values(items).reduce((a,b)=>a+b,0);
      if (totalQty <= maxSlots) return items;
      
      console.warn('[Bundle Builder] Capping items to maximum:', maxSlots);
      let remaining = maxSlots;
      const capped = {};
      
      // Priority: Keep existing items proportionally
      for (const [vid, qty] of Object.entries(items)) {
        if (remaining <= 0) break;
        const cappedQty = Math.min(qty, remaining);
        capped[vid] = cappedQty;
        remaining -= cappedQty;
      }
      
      return capped;
    }
  
    // === HANDLE SECTIONS WITH VERIFICATION (Context7: Defensive Programming) ===
    // Context7: Robust section rendering with DOM verification, state cleanup, and retry logic
    async function handleSectionsWithVerification(data, source = 'bb-bundle', maxRetries = 2) {
      // === RETRY LOGIC (Context7: Conditional Retry, Avoid Unnecessary Retries) ===
      for (let attempt = 0; attempt <= maxRetries; attempt++) {
        const success = await handleSections(data, source);
        if (success) return true;
        
        // Only retry if DOM verification failed AND no items exist in drawer
        const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const cartItems = cartEl?.querySelectorAll('.cart-item') || [];
        if (cartItems.length > 0) {
          // Items exist, render was successful even if verification timed out
          return true;
        }
        
        // Retry with exponential backoff (500ms, 1000ms)
        if (attempt < maxRetries) {
          const delay = attempt === 0 ? 500 : 1000;
          await new Promise(resolve => setTimeout(resolve, delay));
          
          // Refresh sections via GET before retry
          try {
            const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            const RENDER_SECTIONS = (cartEl?.getSectionsToRender?.() || []).map(s => s.section || s.id);
            if (Array.isArray(RENDER_SECTIONS) && RENDER_SECTIONS.length) {
              const url = `${window.location.pathname}?sections=${encodeURIComponent(RENDER_SECTIONS.join(','))}`;
              const res2 = await fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
              const json2 = await res2.json();
              data = { sections: json2 };
            }
          } catch (err) {
            console.error('[Bundle Builder] Refresh failed before retry', err);
          }
        }
      }
      return false;
    }
  
    async function handleSections(data, source = 'bb-bundle') {
      // === INPUT VALIDATION (Context7: Fail Fast) ===
      if (!data || typeof data !== 'object') {
        console.error('[Bundle Builder] Invalid data structure', data);
        return false;
      }
      
      // Normalize data format (handle both {sections: {...}} and direct sections)
      const sections = data.sections || data;
      if (!sections || typeof sections !== 'object') {
        console.error('[Bundle Builder] No sections found in data', data);
        return false;
      }
      
      // === GET DRAWER ELEMENT ===
      const drawerEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (!drawerEl) {
        console.error('[Bundle Builder] Drawer element not found');
        return false;
      }
      
      // === STORE INITIAL STATE (Context7: Initial State Check) ===
      // Context7: Detect structure state to handle empty→filled transitions
      const hasEmptyState = !!drawerEl.querySelector('.drawer__inner-empty');
      const hasFilledState = !!drawerEl.querySelector('.drawer__cart-items-wrapper');
      const initialCount = drawerEl.querySelectorAll('tbody tr.cart-item, .cart-item').length;
      
      // === RENDER CONTENTS (Context7: Defensive Programming) ===
      let renderSuccess = false;
      try {
        if (typeof drawerEl.renderContents === 'function') {
          drawerEl.renderContents({ sections });
          renderSuccess = true;
        } else if (sections) {
          // Fallback: harte Section-Replacements
          for (const [sid, html] of Object.entries(sections)) {
            if (!html) continue;
            const el = document.getElementById(`shopify-section-${sid}`);
            if (el) el.outerHTML = html;
          }
          renderSuccess = true;
        }
      } catch (err) {
        console.error('[Bundle Builder] renderContents failed', err);
      }
      
      // === DOM VERIFICATION (Context7: Trust but Verify, Async-Safe) ===
      await new Promise(resolve => {
        requestAnimationFrame(() => {
          setTimeout(resolve, 200); // Initial 200ms delay for structure transitions
        });
      });
      
      // Wait for DOM mutations to complete (max 2s = 40 checks × 50ms)
      let attempts = 0;
      const maxAttempts = 40;
      const renderVerified = await new Promise(resolve => {
        const verifyRenderSuccess = () => {
          const hasWrapper = !!drawerEl.querySelector('.drawer__cart-items-wrapper');
          const hasTbody = !!drawerEl.querySelector('tbody');
          const cartItems = drawerEl.querySelectorAll('tbody tr.cart-item, .cart-item');
          const currentCount = cartItems.length;
          
          const structureTransition = hasWrapper && hasEmptyState;
          const itemsExist = currentCount > 0;
          const countIncreased = currentCount > initialCount;
          const success = structureTransition || itemsExist || countIncreased;
          
          return success;
        };
        
        const checkInterval = setInterval(() => {
          attempts++;
          const success = verifyRenderSuccess();
          if (success) {
            clearInterval(checkInterval);
            resolve(true);
          } else if (attempts >= maxAttempts) {
            clearInterval(checkInterval);
            console.warn('[Bundle Builder] Verification timeout after', attempts, 'attempts');
            resolve(false);
          }
        }, 50);
      });
      
      // === STATE CLEANUP (Context7: Defensive Programming) ===
      if (renderVerified) {
        drawerEl.classList.remove('is-empty');
        const cartDrawerItems = drawerEl.querySelector('cart-drawer-items');
        if (cartDrawerItems) cartDrawerItems.classList.remove('is-empty');
        
        const emptyState = drawerEl.querySelector('.drawer__inner-empty');
        if (emptyState) {
          emptyState.style.display = 'none';
        }
        
        const itemsRoot = document.getElementById('CartDrawer-CartItems');
        const btn = document.getElementById('CartDrawer-Checkout');
        if (itemsRoot && btn) {
          const hasRow = !!(itemsRoot.querySelector('tbody tr.cart-item:not([style*="display: none"])'));
          if (hasRow) {
            btn.disabled = false;
          }
        }
        
        document.dispatchEvent(new CustomEvent('cart:state-changed', { 
          detail: { from: hasEmptyState ? 'empty' : 'filled', to: 'filled', success: true } 
        }));
      }
      
      // === OPEN DRAWER AND DISPATCH EVENT ===
      if (drawerEl && typeof drawerEl.open === 'function') {
        requestAnimationFrame(() => {
          drawerEl.open();
        });
      }
      
      document.dispatchEvent(new CustomEvent('cart:updated', { 
        detail: { source: source, success: renderVerified } 
      }));
      
      return renderVerified;
    }
  
    async function setLineProps(lineKey, nextProps) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type':'application/json','Accept':'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: lineKey, properties: nextProps })
      });
    }
  
    async function setLineQtyAndProps(lineKey, qty, nextProps) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type':'application/json','Accept':'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: lineKey, quantity: qty, properties: nextProps })
      });
    }
  
    // Nur Zeilen des aktuellen Bundles entfernen, Standalone items ignorieren!
      async function removeAllLinesOfThisProduct(){
        const bundleKey = el.dataset.activeBundleKey;
        if (!bundleKey) return { data: null }; // Kein Bundle aktiv -> nichts löschen

        const cart = await getCartCached();
        const updates = {};
        for (const li of (cart.items || [])) {
          // Nur löschen, wenn Product ID matcht UND der Bundle-Key übereinstimmt
          const liKey = li.properties?._bundle_key || li.properties?.bundle_key;
          if (Number(li.product_id) === productId && liKey === bundleKey) {
            updates[li.key] = 0;
          }
        }
        if (Object.keys(updates).length){
          const { data } = await cartUpdateWithSections(updates);
          return { data };
        }
        return { data: null };
      }
  
      async function readAllBundleGroupsOfProduct(){
        // Context7: Single Source of Truth - Always fetch fresh cart data
        // Using getCartCached() could return stale data if called after API calls that modify cart
        // This ensures we always have the latest cart state, especially after syncCartBundleToState()
        const cart = await fetchCart();
        const map = new Map();
        for (const li of (cart.items || [])) {
          const props = li.properties || {};
          const bkey = props._bundle_key || props.bundle_key || null;
          if (!bkey) continue;
          if (Number(li.product_id) !== productId) continue;
          if (!map.has(bkey)) map.set(bkey, { lines: [], totalQty: 0 });
          const grp = map.get(bkey);
          grp.lines.push({ key: li.key, variantId: li.variant_id, qty: li.quantity, properties: props, productId: li.product_id });
          grp.totalQty += li.quantity;
        }
        return map;
      }
      async function readExistingBundleGroupOfThisProduct(){
        const groups = await readAllBundleGroupsOfProduct();
        if (groups.size === 0) return null;
        const preferred = el.dataset.activeBundleKey && groups.has(el.dataset.activeBundleKey)
          ? el.dataset.activeBundleKey
          : [...groups.entries()].sort((a,b)=>b[1].totalQty - a[1].totalQty)[0][0];
        const grp = groups.get(preferred);
        return { bundleKey: preferred, tier: (grp.lines[0]?.properties?._bundle_tier || grp.lines[0]?.properties?.bundle_tier || null), lines: grp.lines, totalQty: grp.totalQty };
      }
      async function readBundleGroupByKey(bundleKey){
        const groups = await readAllBundleGroupsOfProduct();
        if (!groups.has(bundleKey)) return null;
        const grp = groups.get(bundleKey);
        return { bundleKey, tier: (grp.lines[0]?.properties?._bundle_tier || grp.lines[0]?.properties?.bundle_tier || null), lines: grp.lines, totalQty: grp.totalQty };
      }
      /**
       * Load bundle state from cart with strict quantity aggregation
       * Context7: Single Source of Truth - Aggregates quantities from all lines per variant
       * 
       * This function handles split lines correctly by summing quantities for the same variant.
       * Example: Cart has Line A (Vanille x 1) and Line B (Vanille x 2) -> state.items['vanille_id'] = 3
       */
      async function loadBundleFromCartIntoState(){
        const grp = await readExistingBundleGroupOfThisProduct();
        state.items = {};
        if (grp) { 
          // Context7: Strict aggregation - sum all quantities per variant (handles split lines)
          // Iterate over all lines and aggregate quantities by variant ID
          for (const ln of grp.lines) {
            const vid = String(ln.variantId);
            // Add quantity to existing total (handles multiple lines for same variant)
            state.items[vid] = (state.items[vid] || 0) + ln.qty;
          }
          
          // Context7: Resilience - Self-correct if server data is invalid
          const totalQty = Object.values(state.items).reduce((a,b)=>a+b,0);
          if (totalQty > maxSlots) {
            console.warn('[Bundle Builder] loadBundleFromCartIntoState: Server data exceeds maximum, capping to', maxSlots);
            state.items = capToMaximum(state.items, maxSlots);
          }
          el.dataset.activeBundleKey = grp.bundleKey; 
          el.dataset.cartDirty = '0';
        } else { 
          // Bundle wurde aus Warenkorb gelöscht: State komplett zurücksetzen
          el.dataset.activeBundleKey = ''; 
          el.dataset.cartDirty = '0';
          // Sheet-UI auf Initial-Zustand zurücksetzen (alle qty = 0)
          if (isMobile() && sheet) {
            sheetItems = {};
            mobile_updateSheetQuantities();
            mobile_updateSheetSummary();
            updateMilestoneChips(0);
          }
        }
        return grp;
      }
  
      function computeTierLine(totalQty){
        if (isSmartSet) return ''; // Smart Sets haben keine Tier-Message
        const nextTier = tiers.find(t => t.qty > totalQty);
        let currentTier = null; for (const t of tiers) if (totalQty >= t.qty) currentTier = t;
        if (totalQty === 0) return '';
        if (!currentTier) return nextTier ? `<strong>Noch ${nextTier.qty - totalQty} Booster für ${nextTier.off}% Rabatt.</strong>` : '';
        const base = `<strong>${currentTier.off}% Rabatt</strong> auf alle ausgewählten Booster aktiviert.`;
        if (nextTier) return `${base} <strong>Noch ${nextTier.qty - totalQty} Booster für ${nextTier.off}% Rabatt.</strong>`;
        return base;
      }
      
      function computeHint(totalQty){
        const itemName = isSmartSet ? 'Produkte' : 'Booster';
        if (totalQty === 0) return `Klickt auf die Karten, um ${itemName} hinzuzufügen. <br/> Wenn ihr fertig seid, legt eure Auswahl <strong>in den Warenkorb</strong>.`;
        return computeTierLine(totalQty);
      }
      
      function computeHintWithContext(totalQty){
        const itemName = isSmartSet ? 'Produkte' : 'Booster';
        const inCart = !!el.dataset.activeBundleKey;
        const isDirty = el.dataset.cartDirty === '1';
        
        if (totalQty === 0 && inCart && isDirty) return `Ihr habt alle ${itemName} wieder abgewählt. <br/> Änderungen noch nicht übernommen – zum Bestätigen bitte <strong>in den Warenkorb legen</strong>.`;
        if (totalQty === 0) return `Klickt auf die Karten, um ${itemName} hinzuzufügen. <br/> Wenn ihr fertig seid, legt eure Auswahl <strong>in den Warenkorb</strong>.`;
        if (inCart && !isDirty && totalQty > 0) return `Ihr habt <strong>${totalQty}</strong> ${itemName} in eurem Warenkorb.`;
        
        const tierLine = computeTierLine(totalQty);
        const lines = []; 
        if (tierLine) lines.push(tierLine);
        // Bei Smart Sets zeigen wir einfach den Count, wenn keine Tiers da sind
        else if (isSmartSet && totalQty > 0) lines.push(`<strong>${totalQty} / ${maxSlots}</strong> ${itemName} ausgewählt.`);
        
        if (isDirty) lines.push('Änderungen noch nicht übernommen – zum Bestätigen bitte <strong>in den Warenkorb legen</strong>.');
        return lines.join('<br/>');
      }
  
      /* ================== UI REFS ================== */
      const $hint   = el.querySelector('[data-bb-hint]');
      const $slots  = Array.from(el.querySelectorAll('.bb__slot'));
      const $total  = el.querySelector('[data-bb-total-qty]');
      const $est    = el.querySelector('[data-bb-estimated]');
      const $submit = el.querySelector('[data-bb-submit]');
  
      const priceMap = Object.fromEntries(
        [...el.querySelectorAll('.bb__card')].map(c => [c.dataset.variantId, Number(c.dataset.variantPrice || el.dataset.unitPrice || 0)])
      );
      const tierBySlot = new Map(); tiers.forEach(t => { if (t.qty <= maxSlots) tierBySlot.set(t.qty, t.off); });
  
    function getSlotLabelText(idx){
    const off = tiers.find(t => t.qty === idx)?.off;
    return (typeof off !== 'undefined') ? `−${off}%` : String(idx);
  }
  
      // Labels initialisieren (robust)
      $slots.forEach(slot => {
        const idx   = parseInt(slot.dataset.slot, 10);
        const label = slot.querySelector('[data-bb-label]');
        if (!label) return;
        label.textContent = getSlotLabelText(idx);
      });
  
      function updateSlotInteractivity(){
        const disable = isMobile();
        $slots.forEach(slot => {
          if (disable){
            slot.setAttribute('aria-disabled','true');
            slot.tabIndex = -1;
            slot.disabled = true;             // <-- NEU: echtes disable
          } else {
            slot.removeAttribute('aria-disabled');
            slot.tabIndex = 0;
            slot.disabled = false;            // <-- NEU
          }
        });
      }
  
  updateSlotInteractivity();
  if (mqMobile.addEventListener) mqMobile.addEventListener('change', updateSlotInteractivity);
  else if (mqMobile.addListener) mqMobile.addListener(updateSlotInteractivity);
  
  
      /* ================== RENDER ================== */
   // === PERFORMANCE SCHEDULER (coalesced renders) ===
  let __bb_needsRender = false;
  function __bb_scheduleRender() {
    if (__bb_needsRender) return;
    __bb_needsRender = true;
    requestAnimationFrame(() => {
      __bb_needsRender = false;
      __bb_renderAll();
    });
  }
  
  // Cache häufig benutzter DOM-Refs einmalig
  const __bb_cards = Array.from(el.querySelectorAll('.bb__card'));
  const __bb_cardImgByVid = new Map(
    __bb_cards.map(c => [String(c.dataset.variantId), c.querySelector('img') || null])
  );
  const __bb_slots = Array.from(el.querySelectorAll('.bb__slot'));
  
  // === PERFORMANCE: Shopify Image Optimization Helper ===
  /**
   * Converts Shopify CDN image URLs to optimized thumbnail sizes
   * Context7: Performance Optimization - Reduces bandwidth for slot images (LCP improvement)
   * 
   * Shopify CDN URL patterns:
   * - https://cdn.shopify.com/s/files/1/.../filename_800x.jpg
   * - https://cdn.shopify.com/s/files/1/.../filename_1024x1024.jpg?v=123
   * - https://cdn.shopify.com/s/files/1/.../filename_master.jpg
   * 
   * @param {string} url - Original image URL
   * @param {string} size - Target size (e.g., '160x160_crop_center')
   * @returns {string} - Optimized URL or original if not Shopify CDN
   */
  function getThumbSrc(url, size = '160x160_crop_center') {
    if (!url || typeof url !== 'string') return url || '';
    
    // Check if it's a Shopify CDN URL
    if (!url.includes('cdn.shopify.com')) return url;
    
    // Shopify CDN pattern: filename_SIZE.ext or filename_SIZE.ext?v=...
    // Common sizes: _800x, _1024x1024, _master, _grande, _large, etc.
    
    // Pattern 1: Replace existing size suffix (e.g., _800x, _1024x1024, _master)
    // Matches: _SIZE before file extension, optionally followed by query string
    const sizeSuffixPattern = /_(\d+x\d+|master|grande|large|medium|compact|small|thumb|icon|pico)(?=\.(jpg|jpeg|png|webp|gif|avif)(\?|$|#))/i;
    
    if (sizeSuffixPattern.test(url)) {
      return url.replace(sizeSuffixPattern, `_${size}`);
    }
    
    // Pattern 2: Insert size before file extension if no size suffix exists
    const extPattern = /\.(jpg|jpeg|png|webp|gif|avif)(\?|$|#)/i;
    const extMatch = url.match(extPattern);
    if (extMatch) {
      const ext = extMatch[0];
      return url.replace(ext, `_${size}${ext}`);
    }
    
    // Fallback: return original URL if pattern matching fails
    return url;
  }
  
  // Slot-Helfer: pro Slot ein persistentes <img> wiederverwenden
  function __bb_ensureSlotImg(slot){
    let img = slot.querySelector('img[data-bb-slot-img]');
    if (!img) {
      img = document.createElement('img');
      img.setAttribute('data-bb-slot-img','');
      // Context7: Performance - Lazy loading and async decoding for better LCP
      img.decoding = 'async';
      img.loading = 'lazy';
      img.style.position = 'absolute';
      img.style.inset = '0';
      img.style.pointerEvents = 'none';
      img.style.zIndex = '0';
      img.style.width = '100%';
      img.style.height = '100%';
      img.style.objectFit = 'cover';
      img.style.borderRadius = 'var(--bb-radius)';
      slot.appendChild(img);
    }
    return img;
  }
  
  // Merkt sich die vorherige Menge pro Variante
  const __bb_prevQtyByVid = new Map();
  
  function __bb_renderBadges(){
    const pulse = (el) => {
      el.classList.remove('is-pulse','is-out');
      void el.offsetWidth; // reflow zum Neustarten
      el.classList.add('is-pulse');
    };
  
    const popOut = (el, onDone) => {
      el.classList.remove('is-pulse');
      const token = String(performance.now() + Math.random());
      el.dataset.bbOutToken = token;
  
      el.classList.add('is-out');
      const finish = () => {
        if (el.dataset.bbOutToken === token) {
          el.classList.remove('is-out');
          el.hidden = true;       // erst nach der Animation verstecken
          el.textContent = '';    // keine „0“ im DOM lassen
        }
        el.removeEventListener('animationend', finish);
        if (onDone) onDone();
      };
      el.addEventListener('animationend', finish, { once: true });
    };
  
    for (const card of __bb_cards){
      const vid   = card.dataset.variantId;
      const qty   = state.items[vid] || 0;
      const prev  = __bb_prevQtyByVid.get(vid) || 0;
      const badge = card.querySelector('[data-bb-badge]');
      if (!badge) continue;
  
      // Falls Out läuft aber jetzt wieder >0: abbrechen & zeigen
      if (qty > 0 && badge.classList.contains('is-out')) {
        badge.classList.remove('is-out');
        badge.dataset.bbOutToken = '';
        badge.hidden = false;
      }
  
      // === 0: nie „0“ zeigen ===
  if (qty === 0){
    if (prev > 0 && !badge.hidden){
      // mit Out-Animation ausblenden, DANACH wirklich entfernen
      badge.classList.remove('is-pulse');
      const token = String(performance.now() + Math.random());
      badge.dataset.bbOutToken = token;
      badge.classList.add('is-out');
  
      const finish = () => {
        if (badge.dataset.bbOutToken === token){
          badge.classList.remove('is-out');
          badge.textContent = '';              // keine „0“ im DOM
          badge.setAttribute('aria-hidden','true');
          badge.hidden = true;                 // triggert unser CSS [hidden]{display:none}
          badge.style.display = 'none';        // Hard-Fallback gegen Theme-Overrides
        }
        badge.removeEventListener('animationend', finish);
      };
      badge.addEventListener('animationend', finish, { once:true });
    } else {
      // ohne vorherige Zahl: sofort komplett weg
      badge.classList.remove('is-pulse','is-out');
      badge.textContent = '';
      badge.setAttribute('aria-hidden','true');
      badge.hidden = true;
      badge.style.display = 'none';
    }
  
    __bb_prevQtyByVid.set(vid, qty);
    continue;
  }
  
  
      // === >0: zeigen + pulsen ===
      const needsUnhide =
        badge.hidden ||
        badge.style.display === 'none' ||
        badge.getAttribute('aria-hidden') === 'true' ||
        badge.classList.contains('is-out');
  
      const nextText    = String(qty);
      const textChanged = badge.textContent !== nextText;
  
      if (needsUnhide){
        badge.hidden = false;               // entfernt [hidden]
        badge.style.display = '';           // inline display:none zurücksetzen
        badge.removeAttribute('aria-hidden');
        badge.classList.remove('is-out');   // evtl. laufende Out-Anim abbrechen
        badge.dataset.bbOutToken = '';      // Token invalidieren
      }
  
      if (textChanged) badge.textContent = nextText;
  
      if (needsUnhide) {
        // sauberer Reflow, damit die Pulse-Anim sicher startet
        void badge.offsetWidth;
        requestAnimationFrame(() => {
          badge.classList.remove('is-pulse');
          badge.classList.add('is-pulse');
        });
      } else if (textChanged) {
        badge.classList.remove('is-pulse');
        badge.classList.add('is-pulse');
      }
  
  
      __bb_prevQtyByVid.set(vid, qty);
    }
  }
  
  // Aufräumen nach Puls
  document.addEventListener('animationend', (e)=>{
    if (e.target.matches('.bb__badge.is-pulse')) e.target.classList.remove('is-pulse');
  });
  
  
  // optional: Pulse-Flag automatisch wieder aufräumen
  document.addEventListener('animationend', (e)=>{
    if (e.target.matches('.bb__badge.is-pulse')) e.target.classList.remove('is-pulse');
  });
  
  function __bb_renderSlots(){
    const order = [];
    for (const [vid, qty] of Object.entries(state.items)) {
      for (let i=0; i<qty; i++) order.push(vid);
    }
  
    __bb_slots.forEach((slot, i) => {
      const newVid = order[i] ? String(order[i]) : null;
      const currentVid = slot.dataset.variantId || null;
      
      // Context7: Performance - DOM Diffing: Skip if slot already has correct state
      // Reduces layout thrashing by avoiding unnecessary DOM manipulations
      if (newVid === currentVid && slot.classList.contains('is-filled') === !!newVid) {
        // Slot state matches desired state - skip DOM manipulation
        return;
      }
      
      const label = slot.querySelector('[data-bb-label]');
      const tag   = slot.querySelector('[data-bb-tag]');
      const img   = __bb_ensureSlotImg(slot);
  
      if (newVid) {
        const srcImg = __bb_cardImgByVid.get(newVid);
        const originalSrc = srcImg ? (srcImg.currentSrc || srcImg.src) : '';
        // Context7: Performance - Shopify Image Optimization: Use thumbnail size for slots
        const optimizedSrc = getThumbSrc(originalSrc, '160x160_crop_center');
        const currentSrc = img.getAttribute('src') || '';
        
        // Only update src if it changed (avoids unnecessary network requests)
        if (currentSrc !== optimizedSrc) {
          img.setAttribute('src', optimizedSrc || '');
        }
        
        // Only manipulate DOM if state actually changed
        if (img.hidden) img.hidden = false;
        if (!slot.classList.contains('is-filled')) slot.classList.add('is-filled');
        if (currentVid !== newVid) {
          slot.dataset.variantId = newVid;
          slot.setAttribute('aria-label', `Slot ${slot.dataset.slot} belegt`);
        }
  
        if (label && !label.hidden){ label.hidden = true; label.setAttribute('aria-hidden','true'); }
        if (tag){
          const t = slot.dataset.slot || '';
          if (tag.textContent !== t) tag.textContent = t;
          if (tag.hidden){ tag.hidden = false; tag.removeAttribute('aria-hidden'); }
        }
      } else {
        // leerer Slot
        // Only manipulate DOM if slot was previously filled
        if (currentVid) {
          img.hidden = true; // << entscheidend: Bild ausblenden
          img.removeAttribute('src');  // verhindert Restframe / garantiert echtes "Weg"
          slot.classList.remove('is-filled');
          slot.removeAttribute('data-variant-id');
          const idx = parseInt(slot.dataset.slot,10);
          slot.setAttribute('aria-label', `Slot ${idx} leer`);
        }
        
        if (label){
          const want = getSlotLabelText(parseInt(slot.dataset.slot,10));
          if (label.textContent !== want) label.textContent = want;
          if (label.hidden){ label.hidden = false; label.removeAttribute('aria-hidden'); }
        }
        if (tag){
          if (tag.textContent !== '') tag.textContent = '';
          if (!tag.hidden){ tag.hidden = true; tag.setAttribute('aria-hidden','true'); }
        }
      }
    });
  }
  
  
  let __bb_lastTierQty = 0;
  function __bb_renderSummary(){
    // Hint
    if ($hint){
      const html = computeHintWithContext(state.totalQty);
      if ($hint.innerHTML !== html) $hint.innerHTML = html;
    }
  
    // Tier-Visualisierung in Slots
    let currentTier = null; for (const t of tiers) if (state.totalQty >= t.qty) currentTier = t;
    for (const slot of __bb_slots){
      const idx = parseInt(slot.dataset.slot,10);
      const off = tierBySlot.get(idx);
      const shout = slot.querySelector('[data-bb-shout]');
      const isCurrent = !!currentTier && off === currentTier.off && idx === currentTier.qty;
      const reached   = state.totalQty >= idx;
  
      slot.classList.toggle('is-tier-current', isCurrent);
      slot.classList.toggle('is-tier-reached', reached && !isCurrent);
  
      if (typeof off !== 'undefined'){
        if (isCurrent){
          const text = `−${off}% erreicht`;
          if (shout){
            if (shout.textContent !== text) shout.textContent = text;
            if (shout.hidden){ shout.hidden = false; shout.setAttribute('aria-label', `−${off}% erreicht bei ${idx} Artikeln`); }
          }
        } else if (shout && !shout.hidden) {
          shout.hidden = true; shout.removeAttribute('aria-label');
        }
      }
    }
  
    if (currentTier && currentTier.qty !== __bb_lastTierQty){
      __bb_lastTierQty = currentTier.qty;
      bbTrack('tier_reached', { qty: currentTier.qty, off: currentTier.off });
      const slot = __bb_slots.find(s => parseInt(s.dataset.slot,10) === currentTier.qty);
      slot?.classList.add('just-earned');
      setTimeout(()=>slot?.classList.remove('just-earned'), 800);
    }
  
    if ($total) $total.textContent = state.totalQty;
  
    if ($est){
      const estSubtotal = Object.entries(state.items)
        .reduce((sum, [vid, qty]) => sum + (priceMap[vid] || unitPrice) * qty, 0);
      const estDiscount = state.tier ? Math.round(estSubtotal * state.tier.off / 100) : 0;
      const estTotal = estSubtotal - estDiscount;
      const html = state.totalQty
        ? `${fmtMoney(estTotal, moneyFormat)} <span class="bb__est-note">(−${state.tier ? state.tier.off : 0}% voraussichtlich)</span>`
        : '';
      if ($est.innerHTML !== html) $est.innerHTML = html;
    }
    if ($submit) $submit.disabled = state.totalQty === 0;
  
    // Mobile Hooks
    mobile_updateSticky();
    mobile_updateSheetSummary();
    mobile_updateSheetQuantities();
    updateMilestoneChips();
  }
  
  // === PERFORMANCE: Optimistic UI - Immediate Summary Update ===
  /**
   * Updates summary message and price immediately (before server sync)
   * Context7: Perceived Performance - User sees instant feedback
   * 
   * This function updates only the critical UI elements (hint text and estimated price)
   * to provide immediate visual feedback while the server request is processing.
   * The optimistic state assumes the sync will succeed.
   */
  function renderSummaryImmediate(){
    // Update hint text immediately (shows "Ihr habt X Booster..." instantly)
    if ($hint){
      // Compute hint with optimistic state (assumes sync will succeed)
      // We show the "in cart" message immediately if totalQty > 0
      const optimisticInCart = state.totalQty > 0;
      const itemName = isSmartSet ? 'Produkte' : 'Booster';
      const optimisticHtml = optimisticInCart 
        ? `Ihr habt <strong>${state.totalQty}</strong> ${itemName} in eurem Warenkorb.`
        : computeHintWithContext(state.totalQty);
      
      if ($hint.innerHTML !== optimisticHtml) $hint.innerHTML = optimisticHtml;
    }
    
    // Update estimated price immediately
    if ($est){
      const estSubtotal = Object.entries(state.items)
        .reduce((sum, [vid, qty]) => sum + (priceMap[vid] || unitPrice) * qty, 0);
      const estDiscount = state.tier ? Math.round(estSubtotal * state.tier.off / 100) : 0;
      const estTotal = estSubtotal - estDiscount;
      const html = state.totalQty
        ? `${fmtMoney(estTotal, moneyFormat)} <span class="bb__est-note">(−${state.tier ? state.tier.off : 0}% voraussichtlich)</span>`
        : '';
      if ($est.innerHTML !== html) $est.innerHTML = html;
    }
    
    // Context7: Mobile UX Consistency - Update mobile UI elements immediately
    // These functions are defined later in the code but available at runtime (same scope)
    if (typeof mobile_updateSticky === 'function') {
      mobile_updateSticky();
    }
    if (typeof mobile_updateSheetSummary === 'function') {
      mobile_updateSheetSummary();
    }
    if (typeof mobile_updateSheetQuantities === 'function') {
      mobile_updateSheetQuantities();
    }
  }
  
  // Öffentliche Wrapper – bestehende Aufrufe müssen nicht geändert werden
  function updateUI(){ __bb_scheduleRender(); }
  function markDirty(){ el.dataset.cartDirty = '1'; __bb_scheduleRender(); }
  
  // Zentraler Render
  function __bb_renderAll(){
    __bb_renderSlots();
    __bb_renderBadges();
    __bb_renderSummary();
  }
  
  
      const firstEmptySlot = () => $slots.find(s => !s.classList.contains('is-filled'));
  
      // Animation (Desktop)
      async function flyToSlot(fromImg, toSlot){
        if (!fromImg || !toSlot) { updateUI(); return; }
        void fromImg.offsetWidth; void toSlot.offsetWidth;
        const imgRect  = fromImg.getBoundingClientRect();
        const slotRect = toSlot.getBoundingClientRect();
        if (slotRect.width === 0 || slotRect.height === 0) { updateUI(); return; }
        const ghost = fromImg.cloneNode(true);
        
        // Context7: Performance - GPU acceleration for smooth animations
        // will-change forces browser to promote element to its own compositing layer
        Object.assign(ghost.style, { 
          position:'fixed', 
          left:`${imgRect.left}px`, 
          top:`${imgRect.top}px`, 
          width:`${imgRect.width}px`, 
          height:`${imgRect.height}px`, 
          zIndex:'9999', 
          pointerEvents:'none',
          willChange: 'transform, opacity' // Performance: GPU layer promotion
        });
        
        document.body.appendChild(ghost);
        const scaleX = slotRect.width  / imgRect.width;
        const scaleY = slotRect.height / imgRect.height;
        const dx = slotRect.left - imgRect.left;
        const dy = slotRect.top  - imgRect.top;
        try {
          const anim = ghost.animate(
            [{ transform:'translate(0,0) scale(1)', opacity:1 },
             { transform:`translate(${dx}px, ${dy}px) scale(${scaleX}, ${scaleY})`, opacity:1 }],
            { duration: 420, easing: 'cubic-bezier(.22,.61,.36,1)', fill:'forwards' }
          );
          await anim.finished;
        } catch(e) {} finally { 
          // Clean up will-change after animation to free GPU resources
          ghost.style.willChange = 'auto';
          ghost.remove(); 
        }
        updateUI();
      }
  
      // Karten-Klick (Desktop add)
      el.querySelectorAll('[data-bb-card]').forEach(cardMedia=>{
        const card = cardMedia.closest('.bb__card');
        const vid  = card?.dataset.variantId;
        const img  = cardMedia.querySelector('img');
        cardMedia.addEventListener('click', async () => {
          if (!vid) return;
          if (Object.values(state.items).reduce((a,b)=>a+b,0) >= maxSlots) return;
          const targetSlot = firstEmptySlot(); if (!targetSlot) return;
          state.items[vid] = (state.items[vid] || 0) + 1;
          markDirty();
          if (img) await flyToSlot(img, targetSlot); else updateUI();
        });
      });
  
      // Slot-Klick: Desktop entfernt 1, Mobile ignoriert Tap (Bottom-Sheet macht +/-)
      $slots.forEach(slot=>{
        slot.addEventListener('click', () => {
          if (isMobile()) return;
          const vid = slot.dataset.variantId;
          if (!vid) return;
          const cur = state.items[vid] || 0;
          // Context7: Defensive Programming - Validate before modifying
          if (cur <= 1) {
            delete state.items[vid];
          } else {
            state.items[vid] = cur - 1;
          }
          // Context7: Fail Fast - Validate total after modification
          const totalQty = Object.values(state.items).reduce((a,b)=>a+b,0);
          if (totalQty > maxSlots) {
            console.warn('[Bundle Builder] Slot click: Total quantity exceeds maximum, capping');
            state.items = capToMaximum(state.items, maxSlots);
          }
          markDirty(); 
          updateUI();
        });
      });
  
      function updateMilestoneChips(qOverride){
        if (!isMobile()) return;
        const sheetEl = document.getElementById('bb-sheet'); if (!sheetEl) return;
        const q = (typeof qOverride === 'number') ? qOverride : state.totalQty;
        const milestones = [0, ...tiers.map(t => t.qty)];
        const active = milestones.filter(m => q >= m).pop() ?? 0;
        sheetEl.querySelectorAll('.bb-milestones .bb-chip').forEach(chip=>{
          chip.classList.toggle('is-active', Number(chip.dataset.m) === active);
        });
      }
  
  
      /* ================== SYNC UI -> CART ================== */
  
      let __bb_syncing = false;
      // Verhindert, dass ältere Sync-Ergebnisse neuere Eingaben überschreiben
      let __bb_syncVersion = 0;
      // Hilfsfunktion: prüft nach Await, ob dieser Sync noch “aktuell” ist
      function __bb_isStale(v){ return v !== __bb_syncVersion; }
  
  
  
      /**
       * OPTIMIZED SYNC: Single-pass sync with batch operations
       * Context7: Single Source of Truth, Fail Fast, Defensive Programming
       * 
       * Analyzes the difference between local state.items and cart, then executes
       * minimal batch operations (1x add + 1x update) to sync the cart.
       */
      async function syncCartBundleToState(){
        if (__bb_syncing) return;
        __bb_syncing = true;
        const __v = ++__bb_syncVersion;
  
        try {
          // === INPUT VALIDATION & MAXIMUM ENFORCEMENT ===
          const desiredMap = new Map(
            Object.entries(state.items)
              .filter(([,q]) => q > 0)
              .map(([vid,q]) => [Number(vid), q])
          );
          let totalQty = Array.from(desiredMap.values()).reduce((a,b)=>a+b,0);
          
          // Context7: Fail Fast - Enforce maximum before processing
          if (totalQty > maxSlots) {
            console.warn('[Bundle Builder] Total quantity exceeds maximum, capping to', maxSlots);
            const cappedItems = capToMaximum(state.items, maxSlots);
            state.items = cappedItems;
            // Recreate desiredMap from capped state
            desiredMap.clear();
            for (const [vid, qty] of Object.entries(state.items).filter(([,q]) => q > 0)) {
              desiredMap.set(Number(vid), qty);
            }
            totalQty = Array.from(desiredMap.values()).reduce((a,b)=>a+b,0);
          }
          
          if (__bb_isStale(__v)) { __bb_syncing = false; return; }
  
          // === TIER CALCULATION ===
          let currentTier = null;
          for (const t of tiers) if (totalQty >= t.qty) currentTier = t;
          const newTierStr = currentTier ? `${currentTier.qty}@${currentTier.off}` : 'none';
  
          // === GET CURRENT CART STATE ===
          const cart = await fetchCart();
          if (__bb_isStale(__v)) { __bb_syncing = false; return; }
  
          // === ANALYZE CART: Find all items of this product (with or without bundle_key) ===
          const cartItemsByVariant = new Map(); // variantId -> Array of { key, quantity, properties, bundleKey }
          
          for (const item of (cart.items || [])) {
            if (Number(item.product_id) !== productId) continue;
            
            const vid = Number(item.variant_id);
            const props = item.properties || {};
            const itemBundleKey = props._bundle_key || props.bundle_key || null;
            
            if (!cartItemsByVariant.has(vid)) {
              cartItemsByVariant.set(vid, []);
            }
            
            cartItemsByVariant.get(vid).push({
              key: item.key,
              quantity: item.quantity,
              properties: props,
              bundleKey: itemBundleKey
            });
          }
  
          // === DETERMINE BUNDLE KEY ===
          // Use existing bundle key if available, otherwise create new one
          let bundleKey = el.dataset.activeBundleKey || null;
          if (!bundleKey && totalQty > 0) {
            // Check if there's an existing bundle group
            const existing = await readExistingBundleGroupOfThisProduct();
            bundleKey = existing?.bundleKey || `B-${Date.now()}`;
          }
  
          // === CALCULATE DIFF: What needs to be added, updated, or removed ===
          // Context7: Aggregated quantities - ensure single line per variant with correct properties
          const itemsToAdd = []; // { id, quantity, properties } - aggregated quantities
          const updates = {}; // lineKey -> quantity
          
          // Process each desired variant (desiredMap is already aggregated from state.items)
          for (const [vid, desiredQty] of desiredMap.entries()) {
            const cartLines = cartItemsByVariant.get(vid) || [];
            
            // Group lines by bundle key to find the right line to update
            const linesByBundleKey = new Map();
            for (const line of cartLines) {
              const bkey = line.bundleKey || 'standalone';
              if (!linesByBundleKey.has(bkey)) {
                linesByBundleKey.set(bkey, []);
              }
              linesByBundleKey.get(bkey).push(line);
            }
            
            // FIX: STRICT ISOLATION MODE
            // Wir betrachten NUR Zeilen, die exakt unseren bundleKey haben.
            // Standalone-Items werden ignoriert und nicht "adoptiert".
            
            let bundleLines = [];
            if (bundleKey) {
              // Nur Zeilen, die bereits Teil dieses Bundles sind
              bundleLines = linesByBundleKey.get(bundleKey) || [];
            } else {
              // Wenn wir noch gar keinen Key haben, haben wir logischerweise auch keine Zeilen im Cart,
              // die wir updaten wollen. Wir fangen bei Null an (Add-Mode).
              bundleLines = [];
            }
            
            // Sort lines by key to ensure consistent head selection
            bundleLines.sort((a, b) => a.key.localeCompare(b.key));
            
            // Calculate aggregated current quantity (sum of all lines for this variant)
            const currentQty = bundleLines.reduce((sum, line) => sum + line.quantity, 0);
            
            // Check if head line has correct properties
            const headLine = bundleLines.length > 0 ? bundleLines[0] : null;
            const headHasCorrectProps = headLine && 
              headLine.bundleKey === bundleKey && 
              (headLine.properties?._bundle_tier || headLine.properties?.bundle_tier) === newTierStr;
            
            if (bundleLines.length === 0) {
              // Variant doesn't exist in cart -> add it with aggregated quantity
              itemsToAdd.push({
                id: vid,
                quantity: desiredQty, // Already aggregated from state.items
                properties: {
                  _bundle_key: bundleKey,
                  _bundle_tier: newTierStr
                }
              });
            } else if (bundleLines.length === 1 && headHasCorrectProps && currentQty === desiredQty) {
              // Perfect match: single line, correct props, correct quantity -> no action needed
              // Skip this variant
            } else {
              // We have split lines OR wrong quantity OR wrong properties -> consolidate
              // Strategy: Remove all existing lines, add one clean aggregated line
              
              // Set all existing lines to 0 (will be cleaned up)
              for (const line of bundleLines) {
                updates[line.key] = 0;
              }
              
              // Add one clean line with aggregated quantity and correct properties
              itemsToAdd.push({
                id: vid,
                quantity: desiredQty, // Already aggregated from state.items
                properties: {
                  _bundle_key: bundleKey,
                  _bundle_tier: newTierStr
                }
              });
            }
          }
          
          // === REMOVE VARIANTS: Items in cart but not in desired state ===
          // Nur Items entfernen, die explizit zu DIESEM Bundle gehören.
          if (bundleKey) { 
            for (const [vid, cartLines] of cartItemsByVariant.entries()) {
              if (desiredMap.has(vid)) continue; // Bereits oben behandelt

              // Filtere strikt nach Bundle Key
              const linesBelongingToBundle = cartLines.filter(line => line.bundleKey === bundleKey);
              
              for (const line of linesBelongingToBundle) {
                updates[line.key] = 0;
              }
            }
          }
          
          // === HANDLE OTHER BUNDLES: Remove items from other bundles ===
          // Items from other bundles are already handled in the first phase if they're in desiredMap
          // Here we only need to remove items from other bundles that are NOT in desiredMap
          /*
          if (bundleKey && totalQty > 0) {
            for (const [vid, cartLines] of cartItemsByVariant.entries()) {
              if (desiredMap.has(vid)) continue; // Already handled in first phase
              
              const otherBundleLines = cartLines.filter(line => {
                const lineBundleKey = line.bundleKey || null;
                return lineBundleKey && lineBundleKey !== bundleKey;
              });
              
              // Remove items from other bundles that are not in desired state
              for (const line of otherBundleLines) {
                updates[line.key] = 0;
              }
            }
          }
            */
  
          // === SPECIAL CASE: Remove all items (Active Bundle Only) ===
          if (totalQty === 0 && bundleKey) {
            // Nur Zeilen mit dem aktuellen bundleKey entfernen
            for (const lines of cartItemsByVariant.values()) {
              for (const line of lines) {
                if (line.bundleKey === bundleKey) {
                  updates[line.key] = 0;
                }
              }
            }
            itemsToAdd.length = 0; 
          }
  
          // === BATCH EXECUTION: Execute update and add operations sequentially ===
          // Context7: Sequential execution to avoid race conditions
          // First: Remove/update existing lines (set split lines to 0)
          // Then: Add new aggregated lines with correct properties
          const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const RENDER_SECTIONS = (cartEl?.getSectionsToRender?.() || []).map(s => s.section || s.id);
          
          let finalSections = null;
  
          // Step 1: Update existing items FIRST (remove split lines, update quantities)
          // This must happen before adding new items to avoid duplicates
          if (Object.keys(updates).length > 0) {
            const { data } = await cartUpdateWithSections(updates);
            if (__bb_isStale(__v)) { __bb_syncing = false; return; }
            finalSections = data?.sections || null;
          }
  
          // Step 2: Add new items AFTER updates (ensures clean state)
          // All items in itemsToAdd have aggregated quantities and correct properties
          if (itemsToAdd.length > 0) {
            const addPayload = { items: itemsToAdd };
            if (Array.isArray(RENDER_SECTIONS) && RENDER_SECTIONS.length) {
              addPayload.sections = RENDER_SECTIONS.join(',');
              addPayload.sections_url = window.location.pathname;
            }
            
            const res = await fetch((window.Shopify?.routes?.cart_add_url || '/cart/add') + '.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/json'
              },
              credentials: 'same-origin',
              body: JSON.stringify(addPayload)
            });
            
            if (__bb_isStale(__v)) { __bb_syncing = false; return; }
            
            const data = await res.json();
            // Use sections from add if available (more recent), otherwise keep update sections
            finalSections = data?.sections || finalSections;
          }
  
          // === UPDATE PROPERTIES: Ensure all items have correct bundle_key and tier ===
          // This is a safety net - ideally properties are set correctly during add/update
          if (bundleKey && totalQty > 0) {
            // Fetch fresh cart to get updated line keys
            const freshCart = await fetchCart();
            if (__bb_isStale(__v)) { __bb_syncing = false; return; }
            
            const propUpdatePromises = [];
            for (const item of (freshCart.items || [])) {
              if (Number(item.product_id) !== productId) continue;
              if (!desiredMap.has(Number(item.variant_id))) continue;
              
              const props = item.properties || {};
              const itemBundleKey = props._bundle_key || props.bundle_key || null;
              
              // Wir fassen NUR Items an, die bereits UNSEREN Key haben.
              // Wir "stehlen" keine Standalone Items (itemBundleKey === null) mehr.
              if (itemBundleKey !== bundleKey) continue;

              const itemTier = props._bundle_tier || props.bundle_tier || null;
              const needsTierUpdate = itemTier !== newTierStr;
              
              if (needsTierUpdate) {
                const updatedProps = Object.assign({}, props);
                // _bundle_key bleibt gleich, nur Tier wird geupdated
                updatedProps._bundle_tier = newTierStr;
                propUpdatePromises.push(setLineProps(item.key, updatedProps));
              }
            }
            
            // Wait for property updates (non-blocking, but we wait to ensure consistency)
            if (propUpdatePromises.length > 0) {
              await Promise.all(propUpdatePromises);
            }
          }
  
          // === RENDER SECTIONS ===
          if (finalSections) {
            await handleSectionsWithVerification({ sections: finalSections }, 'bb-sync');
          } else if (cartEl?.renderContents && Array.isArray(RENDER_SECTIONS) && RENDER_SECTIONS.length) {
            // Fallback: GET request if no sections available
        const url = `${window.location.pathname}?sections=${encodeURIComponent(RENDER_SECTIONS.join(','))}`;
        const res2 = await fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        const json2 = await res2.json();
            await handleSectionsWithVerification({ sections: json2 }, 'bb-sync-refresh');
          }
  
          // === UPDATE STATE FROM SERVER ===
          // Context7: Performance - Trust local state after successful sync (no redundant fetch)
          // We work in draft mode, so state.items is already correct after successful add/update
          if (totalQty === 0) {
            el.dataset.activeBundleKey = '';
            el.dataset.cartDirty = '0';
            state.items = {};
          } else {
            el.dataset.activeBundleKey = bundleKey;
            el.dataset.cartDirty = '0';
            // OPTIMIZED: No re-fetch needed here. Local state is trusted after success.
          }
          
        updateUI();
  
        } catch (error) {
          console.error('[Bundle Builder] syncCartBundleToState error:', error);
          // On error, reload state from cart to ensure consistency
          __bb_cartCache = null;
          await loadBundleFromCartIntoState();
          updateUI();
    } finally {
          // Context7: Invalidate cart cache at end of sync cycle
          __bb_cartCache = null;
      __bb_syncing = false;
    }
  }
  
  
  
  
  
 /* ================== FORM INTERCEPT (unverändert) ================== */
  
  
  
  function bbToggleATCSpinner(on) {
    // Haupt-ATC des aktuellen Produkts finden (wie im Sticky-Code)
    const productForms = Array.from(document.querySelectorAll('form[action^="/cart/add"]'));
    const productForm  = productForms.find(f => f.querySelector('button[name="add"], [type="submit"]')) || productForms[0];
    if (!productForm) return;
  
    const btn = productForm.querySelector('button[name="add"], [type="submit"]');
    if (!btn) return;
  
    // Falls das Theme bereits einen Spinner-Container hat, nutzen wir ihn.
    let spinner = btn.querySelector('.loading-overlay__spinner');
    if (!spinner) {
      spinner = document.createElement('div');
      spinner.className = 'loading-overlay__spinner hidden';
      // Dawn-ähnlicher SVG-Spinner
      spinner.innerHTML = `
        <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      `;
      btn.appendChild(spinner);
    }
  
    if (on) {
      btn.classList.add('loading');
      btn.setAttribute('aria-busy', 'true');
      spinner.classList.remove('hidden');
      // bereits von dir gesetzt: disabled + Cursor – lassen wir bestehen
    } else {
      btn.classList.remove('loading');
      btn.removeAttribute('aria-busy');
      spinner.classList.add('hidden');
    }
  }
  
  
  
  
      const variantIdsInThisProduct = new Set([...el.querySelectorAll('.bb__card')].map(c => String(c.dataset.variantId)));
      function isFormForThisProduct(form) {
        const idInput = form.querySelector('input[name="id"]');
        const vid = idInput && idInput.value ? String(idInput.value) : '';
        return vid && variantIdsInThisProduct.has(vid);
      }
  
   document.addEventListener('submit', async (evt) => {   
  const form = evt.target?.closest('form[action*="/cart/add"]'); if (!form) return;
  if (!isFormForThisProduct(form)) return;
  evt.preventDefault(); evt.stopPropagation(); evt.stopImmediatePropagation?.();
  
  // Context7: Safety - Double-Submit Prevention
  const submitBtn = form.querySelector('button[name="add"], button[type="submit"]');
  const wasDisabled = submitBtn?.disabled || form.disabled;
  if (submitBtn) submitBtn.disabled = true;
  if (form) form.disabled = true;
  
  try {
    // Context7: Perceived Performance - Update UI immediately (optimistic)
    renderSummaryImmediate();
    
    if (!isMobile()) bbToggleATCSpinner(true);
    await syncCartBundleToState();
    if (openCartAfterAdd) {
      const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      cartEl?.open?.();
    }
  } finally {
    if (!isMobile()) bbToggleATCSpinner(false);
    // Restore button/form state (only if it wasn't disabled before)
    if (submitBtn && !wasDisabled) submitBtn.disabled = false;
    if (form && !wasDisabled) form.disabled = false;
  }     
      }, true);
  
  
        document.addEventListener('click', async (evt) => {
  const btn = evt.target?.closest('product-form button[name="add"], form[action*="/cart/add"] button[type="submit"]'); if (!btn) return;
  const form = btn.closest('form[action*="/cart/add"]'); if (!form) return;
  if (!isFormForThisProduct(form)) return;
  evt.preventDefault(); evt.stopPropagation(); evt.stopImmediatePropagation?.();
  
  // Context7: Safety - Double-Submit Prevention
  const wasDisabled = btn.disabled || form.disabled;
  btn.disabled = true;
  if (form) form.disabled = true;
  
  try {
    // Context7: Perceived Performance - Update UI immediately (optimistic)
    renderSummaryImmediate();
    
    if (!isMobile()) bbToggleATCSpinner(true);
    await syncCartBundleToState();
    if (openCartAfterAdd) {
      const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      cartEl?.open?.();
    }
  } finally {
    if (!isMobile()) bbToggleATCSpinner(false);
    // Restore button/form state (only if it wasn't disabled before)
    if (!wasDisabled) btn.disabled = false;
    if (form && !wasDisabled) form.disabled = false;
  }
      }, true);
  
  
     const cartDrawerObserverTarget = document.querySelector('cart-drawer');
  if (cartDrawerObserverTarget) {
    let moTimer;
    const mo = new MutationObserver(() => {
      clearTimeout(moTimer);
      moTimer = setTimeout(async () => {
        // A) Sobald der Drawer geöffnet ist: Overlay SOFORT schließen
        if (cartDrawerObserverTarget.hasAttribute('open')) {
          bbMobileLoadingHide();
        } else if (__bb_syncing) {
          // User hat während Sync den Drawer wieder zugemacht
          __bb_userClosedDuringSync = true;
        }
  
        // B) Nichts am PDP ändern, solange Sync läuft oder Sheet offen ist
        if (__bb_syncing || document.body.classList.contains('bb--lock')) return;
  
        // C) PDP nur zurücksetzen, wenn der Cart wirklich leer ist oder Produkt nicht mehr vorkommt
        // Context7: Use fresh cart fetch here - MutationObserver runs outside sync cycle and needs current state
        // Using getCartCached() could return stale data if sync is in progress
        const cart = await fetchCart();
        const items = cart.items || [];
        if (!items.length) {
          state.items = {};
          el.dataset.activeBundleKey = '';
          el.dataset.cartDirty = '0';
          el.querySelectorAll('.bb__slot img[data-bb-slot-img]').forEach(n => n.remove());
          // Sheet-UI auf Initial-Zustand zurücksetzen
          if (isMobile() && sheet) {
            sheetItems = {};
            mobile_updateSheetQuantities();
            mobile_updateSheetSummary();
            updateMilestoneChips(0);
          }
          updateUI();
          return;
        }
        
        const groups = await readAllBundleGroupsOfProduct();
        const hasAnyOfThisProduct = [...groups.values()].some(g => g.totalQty > 0);
        if (!hasAnyOfThisProduct) {
          state.items = {};
          el.dataset.activeBundleKey = '';
          el.dataset.cartDirty = '0';
          el.querySelectorAll('.bb__slot img[data-bb-slot-img]').forEach(n => n.remove());
          // Sheet-UI auf Initial-Zustand zurücksetzen
          if (isMobile() && sheet) {
            sheetItems = {};
            mobile_updateSheetQuantities();
            mobile_updateSheetSummary();
            updateMilestoneChips(0);
          }
          updateUI();
        }
      }, 180);
    });
    mo.observe(cartDrawerObserverTarget, { attributes:true, attributeFilter:['open'] });
  }
  
  
      loadBundleFromCartIntoState().then(updateUI);
  
      /* ================== MOBILE-ONLY ================== */
      const stickyEl = document.getElementById('bb-sticky');
      const stickyFillEl = stickyEl?.querySelector('.bb-sticky__fill');
      const stickyTextEl = stickyEl?.querySelector('[data-bb-sticky-text]');
      const ticksWrap = stickyEl?.querySelector('[data-bb-ticks]');
      const ctaBtn = document.querySelector('.bb__open-picker');
  
  
      function mobile_buildTicks(){
        if (!isMobile() || !ticksWrap) return;
        ticksWrap.innerHTML = '';
        tiers.forEach(t => {
          const span = document.createElement('span');
          const left = (t.qty / maxSlots) * 100;
          span.style.left = left + '%';
          span.textContent = `−${t.off}%`;
          ticksWrap.appendChild(span);
        });
      }
      function mobile_computeShortSummary(){
        const q = state.totalQty;
        const itemName = isSmartSet ? 'Produkte' : 'Booster';
        
        // Smart Set Logic: Einfacher String
        if (isSmartSet) {
             return `${q}/${maxSlots} ${itemName} ausgewählt`;
        }

        // Booster Logic
        let nextTier = tiers.find(t=>t.qty>q);
        let currentTier = null; for (const t of tiers) if (q>=t.qty) currentTier=t;
        
        // Dynamischer Max-Slot Support im String
        const baseStr = `${q}/${maxSlots} ${itemName}`;
        
        if (q === 0 && tiers.length > 0) return `${baseStr} • ab ${tiers[0].qty} −${tiers[0].off} %`;
        if (!currentTier && nextTier) return `${baseStr} • noch ${nextTier.qty-q} bis −${nextTier.off} %`;
        if (currentTier && nextTier) return `${baseStr} • −${currentTier.off} % aktiv • noch ${nextTier.qty-q} bis −${nextTier.off} %`;
        if (currentTier && !nextTier) return `${baseStr} • −${currentTier.off} % aktiv`;
        return baseStr;
      }
      function mobile_updateSticky(){
        if (!isMobile() || !stickyEl) return;
        const q = state.totalQty;
        const pct = Math.max(0, Math.min(100, (q / maxSlots) * 100));
        if (stickyFillEl) stickyFillEl.style.width = pct + '%';
        if (stickyTextEl) stickyTextEl.textContent = mobile_computeShortSummary();
      }
  
  // ===== Sticky Gate (Bundle Builder) — unified Mobile + Desktop wie Sticky Buy-Me =====
  
  const openFromSticky = stickyEl?.querySelector('[data-bb-open]');
  
  // Sticky sicher unter <body> hängen
  if (stickyEl && stickyEl.parentNode !== document.body) document.body.appendChild(stickyEl);
  
  // Aktivieren (hidden entfernen, Sichtbarkeit nur via Klasse steuern)
  if (stickyEl) {
    stickyEl.removeAttribute('hidden');
    stickyEl.setAttribute('aria-hidden', 'true');
  }
  
  // === Header-Unterkante messen (Desktop-Top-Offset) ===
  function bbMeasureHeaderBottom(){
    const header = document.querySelector('sticky-header, header.header, .header, .header-wrapper, header[role="banner"]');
    const rect = header ? header.getBoundingClientRect() : null;
    const offset = rect ? Math.max(0, rect.bottom) : 0;
    document.documentElement.style.setProperty('--sticky-top-offset', offset + 'px');
  }
  let __bbRaf = null;
  function bbScheduleMeasure(){ 
    if (__bbRaf) return; 
    __bbRaf = requestAnimationFrame(()=>{ __bbRaf=null; bbMeasureHeaderBottom(); }); 
  }
  bbMeasureHeaderBottom();
  window.addEventListener('resize', bbScheduleMeasure, { passive:true });
  window.addEventListener('scroll',  bbScheduleMeasure, { passive:true });
  document.addEventListener('shopify:section:load',    bbScheduleMeasure);
  document.addEventListener('shopify:section:reorder', bbScheduleMeasure);
  
  // === Produkt-Form & echter ATC robust finden (wie Sticky Buy-Me) ===
  const productForms = Array.from(document.querySelectorAll('form[action^="/cart/add"]'));
  const productForm  = productForms.find(f => f.querySelector('button[name="add"], [type="submit"]')) || productForms[0];
  function findMainATC(root){ 
    return root && (root.querySelector('button[name="add"]') || root.querySelector('[type="submit"]')); 
  }
  let mainATC = findMainATC(productForm);
  
  // Mobile CTA als Fallback (nur wenn sichtbar)
  const mobileCTA = document.querySelector('.bb__open-picker');
  
  // KRITISCH: Desktop nutzt echten ATC, Mobile nutzt mobileCTA
  // Anker-Auswahl: wie Sticky Buy-Me – Desktop = mainATC, Mobile = mobileCTA (wenn sichtbar)
  let anchorEl = mainATC || mobileCTA;
  let observedBtn = null;
  
  // Sichtbarkeit togglen
  function bbShow(){ 
    if (!stickyEl) return; 
    stickyEl.classList.add('is-visible'); 
    stickyEl.setAttribute('aria-hidden', 'false'); 
  }
  function bbHide(){ 
    if (!stickyEl) return; 
    stickyEl.classList.remove('is-visible'); 
    stickyEl.setAttribute('aria-hidden', 'true'); 
  }
  
  // === Scroll-Richtung (Gate) ===
  let lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
  let scrollDir = 'down';
  let hasSeenAnchor = false;
  let anchorInView  = true;
  let anchorDocTop  = 0;
  let ioAnchor = null;
  
  function computeDocTop(el){
    const r = el.getBoundingClientRect();
    const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    return r.top + scrollY;
  }
  
  window.addEventListener('scroll', () => {
    const y = window.pageYOffset || document.documentElement.scrollTop || 0;
    const nextDir = (y > lastY) ? 'down' : 'up';
    if (nextDir !== scrollDir) { scrollDir = nextDir; bbDebouncedUpdate(); }
    lastY = y;
  
    // Reentry-Guard (wie Buy-Me): Wenn wir wieder OBERHALB des Anchors sind, Reset
    const viewportBottom = y + (window.innerHeight || document.documentElement.clientHeight);
    if (viewportBottom < (anchorDocTop - 8)) {
      hasSeenAnchor = false;
      anchorInView = false;
      bbHide();
    }
  }, { passive: true });
  
  // === Debounce gegen Flackern ===
  let bbDebounceTimer = null;
  function bbDebouncedUpdate(){
    clearTimeout(bbDebounceTimer);
    bbDebounceTimer = setTimeout(bbUpdateVisibility, 160);
  }
  
  function bbUpdateVisibility(){
    // Regeln: nur zeigen, wenn (hasSeenAnchor) && (scrollDir === 'down') && (!anchorInView) && (!sheetOpen)
    const sheetOpen = document.documentElement.classList.contains('bb--sheet-open');
    const shouldShow = hasSeenAnchor && scrollDir === 'down' && !anchorInView && !sheetOpen;
    if (shouldShow) bbShow(); else bbHide();
  }
  
  // === IntersectionObserver (auf Anchor) ===
  function bbBuildObserver() {
    if (ioAnchor) { try { ioAnchor.disconnect(); } catch(e){} ioAnchor = null; }
    
    if (!('IntersectionObserver' in window)) {
      const r = anchorEl.getBoundingClientRect();
      anchorInView = r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
      if (anchorInView) hasSeenAnchor = true;
      bbDebouncedUpdate();
      return;
    }
    
    const margin = `0px 0px -8px 0px`;
    ioAnchor = new IntersectionObserver((entries) => {
      const entry = entries[0];
      const inView = !!(entry && (entry.isIntersecting || entry.intersectionRatio > 0));
      anchorInView = inView;
      if (inView) hasSeenAnchor = true;
      bbDebouncedUpdate();
    }, { root: null, threshold: 0, rootMargin: margin });
  
    bbAttachObserver();
  }
  
  function bbAttachObserver(){
    if (!ioAnchor) return;
    
    // Anchor neu bestimmen: Desktop = mainATC, Mobile = mobileCTA (falls sichtbar)
    const freshATC = findMainATC(productForm) || mainATC;
    const isMobileLayout = window.matchMedia('(max-width: 989px)').matches;
    
    // KRITISCH: Desktop beobachtet echten ATC, Mobile den sichtbaren mobileCTA
    if (isMobileLayout && mobileCTA) {
      anchorEl = mobileCTA;
    } else if (freshATC) {
      anchorEl = freshATC;
    }
    
    if (!anchorEl) return;
    
    if (observedBtn) ioAnchor.unobserve(observedBtn);
    observedBtn = anchorEl;
    ioAnchor.observe(observedBtn);
  
    // Initialstatus + absolute Top-Position
    const r = observedBtn.getBoundingClientRect();
    anchorInView = r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
    if (anchorInView) hasSeenAnchor = true;
    anchorDocTop = computeDocTop(observedBtn);
    bbDebouncedUpdate();
  }
  
  bbBuildObserver();
  window.addEventListener('resize', () => {
    if (observedBtn) anchorDocTop = computeDocTop(observedBtn);
    bbBuildObserver();
  });
  
  // Provide missing wrapper used earlier to gate/toggle sticky consistently
  function mobile_gateSticky(){
    bbBuildObserver();
    bbDebouncedUpdate();
  }
  
  
  // Sticky-CTA Klicks: Mobile → Sheet, Desktop → zum Builder scrollen
  openFromSticky?.addEventListener('click', (e)=>{
    e.preventDefault();
    const isMobile = window.matchMedia('(max-width: 989px)').matches;
    if (isMobile) {
      // exakt wie dein bestehender Mobile-Handler
      const openBtn = document.querySelector('.bb__open-picker');
      if (openBtn) openBtn.click();
    } else {
      document.getElementById('bundle-builder')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
  
  
  
  
  
  
      // Elemente ggf. direkt unter <body> hängen (Stapelkontext sicher)
      const sheet   = document.getElementById('bb-sheet');
      const scrimGlobal = document.getElementById('bb-scrim');   // <-- neu
      [sheet, stickyEl, scrimGlobal].forEach(node=>{
        if (node && node.parentNode !== document.body) document.body.appendChild(node);
      });
  
  
      // Wir nutzen NUR den globalen Scrim #bb-scrim
      const scrim = null; // Safety: kein Shadow-Scrim
      const panel = sheet?.querySelector('.bb-sheet__panel');
  
  
      const openBtn = ctaBtn;
      // Commit Button: Unterstützt beide Varianten (mit/ohne -global)
      const commit  = sheet?.querySelector('[data-bb-commit], [data-bb-commit-global]');
  
      // ===== Body-Lock & Inert — zentral =====
      let __bbScrollY = 0;
  const setSiblingsInert = (on) => {
    const main   = document.getElementById('MainContent');
    const header = document.querySelector('header');
  
    // MainContent: komplett inert + aria-hidden
    if (main) {
      if (on) {
        main.setAttribute('inert','');
        main.setAttribute('aria-hidden','true');
        main.style.pointerEvents = 'none';
      } else {
        main.removeAttribute('inert');
        main.removeAttribute('aria-hidden');
        main.style.pointerEvents = '';
      }
    }
  
    // ENTFERNEN: header.style.pointerEvents = 'none';
    if (header) {
      header.style.pointerEvents = ''; // sicherheitshalber zurücksetzen
    }
  };
  
      const lockBodyScroll = () => {
        __bbScrollY = window.scrollY || document.documentElement.scrollTop || 0;
        document.body.dataset.bbScrollY = String(__bbScrollY);
        // Overflow-Lock auf html UND body
        document.documentElement.classList.add('bb--lock');
        document.body.classList.add('bb--lock');
      };
  
         // === Freeze/Unfreeze sticky header to avoid logo jumping ===
        function freezeHeaderWhileLocked(){
          const header =
            document.querySelector('sticky-header') ||
            document.querySelector('.header-wrapper') ||
            document.querySelector('header[role="banner"]') ||
            document.querySelector('header');
  
          if (!header) return;
  
          const hr = header.getBoundingClientRect();
  
          // 1) Exakte horizontale Position & Breite einfrieren
          // Wir brauchen --bb-header-left/width nicht mehr, da der Header fix auf left:0; right:0; width:100% gesetzt wird.
          // const wrapperEl = document.querySelector('.header-wrapper') || document.querySelector('sticky-header') || header;
          // if (wrapperEl) {
          //  const wr = wrapperEl.getBoundingClientRect();
          //  document.documentElement.style.setProperty('--bb-header-left', `${Math.round(wr.left + window.scrollX)}px`);
          //  document.documentElement.style.setProperty('--bb-header-width', `${Math.round(wr.width)}px`);
          // }
  
          // 2) Aktuelle Innenabstände konservieren
          const innerHeader = header.querySelector('.header') || header;
          if (innerHeader) {
            const cs = getComputedStyle(innerHeader);
            document.documentElement.style.setProperty('--bb-pad-left', cs.paddingLeft);
            document.documentElement.style.setProperty('--bb-pad-right', cs.paddingRight);
            innerHeader.style.paddingLeft = cs.paddingLeft;
            innerHeader.style.paddingRight = cs.paddingRight;
          }
  
        // 3) Logo-Hard-Freeze (verhindert 1-Frame-Jump)
        const headerRect  = (innerHeader || header).getBoundingClientRect();
        // Sicherheitsnetz: keine Transitions während des Freezes
        document.documentElement.classList.add('bb--freeze-header');
        const logo = header.querySelector('.header__heading img, .header__heading-logo, .site-header__logo-image, img[alt*="Logo"]');
        if (logo) {
          const lr = logo.getBoundingClientRect();
  
          // Größe pixelgenau einfrieren (wie gehabt)
          logo.style.width    = `${lr.width}px`;
          logo.style.height   = `${lr.height}px`;
          logo.style.maxWidth = `${lr.width}px`;
          document.documentElement.style.setProperty('--bb-logo-w', `${lr.width}px`);
          document.documentElement.style.setProperty('--bb-logo-h', `${lr.height}px`);
  
          // NEU: exakte X-Position (Center) relativ zum inneren Header berechnen und als Variable setzen
          const cx = (lr.left - headerRect.left) + (lr.width / 2);
          document.documentElement.style.setProperty('--bb-logo-x', `${Math.round(cx)}px`);
        }
  
        const heading = header.querySelector('.header__heading');
        if (heading) {
          header.style.position = header.style.position || 'relative';
  
          // Vorherige Inline-Styles sichern (für Unfreeze)
          heading.dataset.bbPrevPos       = heading.style.position || '';
          heading.dataset.bbPrevLeft      = heading.style.left || '';
          heading.dataset.bbPrevRight     = heading.style.right || '';
          heading.dataset.bbPrevTransform = heading.style.transform || '';
          heading.dataset.bbPrevMargin    = heading.style.margin || '';
  
          // Absolute Position auf den eingefrorenen Center setzen
          heading.style.position  = 'absolute';
          heading.style.left      = getComputedStyle(document.documentElement).getPropertyValue('--bb-logo-x').trim() || '50%';
          heading.style.right     = 'auto';
          heading.style.transform = 'translateX(-50%)';
          heading.style.margin    = '0';
        }
  
  
          // 4) Höhe & Reserve
          document.documentElement.style.setProperty('--bb-header-h', `${hr.height}px`);
          const wrapperHost = document.querySelector('.header-wrapper') || document.querySelector('sticky-header');
          if (wrapperHost) {
            wrapperHost.style.minHeight = `${hr.height}px`;
            wrapperHost.style.willChange = 'auto';
          }
  
          // 5) Klasse setzen, damit die CSS-Freeze-Regeln greifen
          document.documentElement.classList.add('bb--freeze-header');
        }
  
        function unfreezeHeader(){
          document.documentElement.classList.remove('bb--freeze-header');
          document.documentElement.style.removeProperty('--bb-header-h');
          document.documentElement.style.removeProperty('--bb-logo-w');
          document.documentElement.style.removeProperty('--bb-logo-h');
          document.documentElement.style.removeProperty('--bb-logo-x'); // NEU
  
  
  
          const header =
            document.querySelector('sticky-header') ||
            document.querySelector('.header-wrapper') ||
            document.querySelector('header[role="banner"]') ||
            document.querySelector('header');
  
          const logo =
            header?.querySelector('.header__heading img, .header__heading-logo, .site-header__logo-image, img[alt*="Logo"]') || null;
          if (logo) {
            logo.style.width = '';
            logo.style.height = '';
            logo.style.maxWidth = '';
          }
  
          const _header =
          document.querySelector('sticky-header') ||
          document.querySelector('.header-wrapper') ||
          document.querySelector('header[role="banner"]') ||
          document.querySelector('header');
        const heading = _header?.querySelector('.header__heading');
  
        if (heading) {
          heading.style.position  = heading.dataset.bbPrevPos || '';
          heading.style.left      = heading.dataset.bbPrevLeft || '';
          heading.style.right     = heading.dataset.bbPrevRight || '';
          heading.style.transform = heading.dataset.bbPrevTransform || '';
          heading.style.margin    = heading.dataset.bbPrevMargin || '';
  
          delete heading.dataset.bbPrevPos;
          delete heading.dataset.bbPrevLeft;
          delete heading.dataset.bbPrevRight;
          delete heading.dataset.bbPrevTransform;
          delete heading.dataset.bbPrevMargin;
        }
  
          const wrapper = document.querySelector('.header-wrapper') || document.querySelector('sticky-header');
          if (wrapper) {
            wrapper.style.minHeight = '';   // <— NEU: Reserve zurücknehmen
            wrapper.style.willChange = '';
  
        // horizontale Freeze-Variablen entfernen
        // DELETE diese beiden Zeilen (die Variablen existieren nach obigem Schritt nicht mehr).
        // document.documentElement.style.removeProperty('--bb-header-left');
        // document.documentElement.style.removeProperty('--bb-header-width');
        document.documentElement.style.removeProperty('--bb-pad-left');
        document.documentElement.style.removeProperty('--bb-pad-right');
  
        // inline-Paddings zurücksetzen
        const _hdr =
          document.querySelector('sticky-header') ||
          document.querySelector('.header-wrapper') ||
          document.querySelector('header[role="banner"]') ||
          document.querySelector('header');
  
        const _inner = _hdr?.querySelector('.header') || _hdr;
        if (_inner) {
          _inner.style.paddingLeft = '';
          _inner.style.paddingRight = '';
        }
  
  
          }
        }
  
      const unlockBodyScroll = () => {
        const y = Number(document.body.dataset.bbScrollY || __bbScrollY || 0);
        const html = document.documentElement;
        const prev = html.style.scrollBehavior;
        html.style.scrollBehavior = 'auto';
  
        document.documentElement.classList.remove('bb--lock');
        document.body.classList.remove('bb--lock');
  
        window.scrollTo(0, y);
        html.style.scrollBehavior = prev || '';
        delete document.body.dataset.bbScrollY;
      };
  
      // ===== Bottom-Sheet Open/Close =====
  
  
  // --- Mobile Loading Overlay Helpers ---
  const bbML = document.getElementById('bb-mobile-loading');
  const bbDelay = (ms) => new Promise(r=>setTimeout(r, ms));
  function bbMobileLoadingShow(text){
    // Hänge das Overlay sicher direkt unter <body>, damit kein lokaler Stacking-Context dazwischenfunkt.
  if (bbML && bbML.parentNode !== document.body) {
    document.body.appendChild(bbML);
  }
    if (!bbML) return;
    if (text) bbML.querySelector('.bb-ml__text').textContent = text;
    // Progress zurücksetzen (retrigger animation)
    const bar = bbML.querySelector('.bb-ml__bar > span');
    if (bar){ bar.style.animation='none'; void bar.offsetWidth; bar.style.animation=''; }
    bbML.removeAttribute('hidden');
  }
  function bbMobileLoadingHide(){ bbML?.setAttribute('hidden',''); }
  
  
  
  
  
      let sheetOpen = false;
      let sheetPrevFocus = null;
      let sheetItems = null; // Draft-Auswahl nur im Sheet
  
      function mobile_openSheet(){
        if (!isMobile() || !sheet || sheetOpen) return;
        sheetItems = JSON.parse(JSON.stringify(state.items || {})); // Draft starten
        lockBodyScroll();
        freezeHeaderWhileLocked();
        setSiblingsInert(true);
  
        sheet.removeAttribute('hidden');
        // Vor dem Einblenden: erste 8 Tiles „vorwärmen“
        (function mobile_prewarmSheetImages(limit=8){
          const imgs = sheet.querySelectorAll('.bb-sheet__grid .bb-tile__imgwrap img');
          let n = 0;
          imgs.forEach(img => {
            if (n >= limit) return;
            img.loading = 'eager';
            if (img.decode) { try { img.decode(); } catch(e){} }
            n++;
          });
        })();
        sheet.classList.add('is-open');
        sheetOpen = true;
        bbTrack('sheet_open', { source: 'cta' });
        sheetPrevFocus = document.activeElement;
        panel?.setAttribute('tabindex','-1');
        panel?.focus({ preventScroll: true });
  
        document.documentElement.classList.add('bb--sheet-open');
        // Fail-safe gegen aria-hidden am Logo-Wrapper, falls ein Theme-Skript das setzt
        document.querySelector('.header .header__heading')?.removeAttribute('aria-hidden');
  
        // Nach dem Anwenden der .bb--sheet-open-CSS einmal Layout stabilisieren,
        // dann Logo-Center neu ermitteln und Variable aktualisieren.
        requestAnimationFrame(()=>{
          requestAnimationFrame(()=>{
            (function bbRecalcLogoCenter(){
              const header =
                document.querySelector('sticky-header') ||
                document.querySelector('.header-wrapper') ||
                document.querySelector('header[role="banner"]') ||
                document.querySelector('header');
              const inner = header?.querySelector('.header') || header;
              const logo  = header?.querySelector('.header__heading img, .header__heading-logo, .site-header__logo-image, img[alt*="Logo"]');
              if (!inner || !logo) return;
              const hr = inner.getBoundingClientRect();
              const lr = logo.getBoundingClientRect();
              const cx = (lr.left - hr.left) + (lr.width / 2);
              document.documentElement.style.setProperty('--bb-logo-x', `${Math.round(cx)}px`);
            })();
          });
        });
  
  
        // Sticky ausblenden
        stickyEl?.classList.remove('is-visible');
  
        // Offen: nur das Hidden-Attribut entfernen, CSS macht den Rest
        scrimGlobal?.removeAttribute('hidden');
  
  
        // Quantitäten & Milestones aus Draft spiegeln
        mobile_updateSheetQuantities();
        mobile_updateSheetSummary();
        updateMilestoneChips(Object.values(sheetItems).reduce((a,b)=>a+b,0));
      }
  
        /** Promise-basiertes Zuklappen mit sauberer Reihenfolge */
        function closeSheetAsync(){
          if (!sheetOpen || !sheet) return Promise.resolve();
  
          sheet.classList.remove('is-open');
          sheet.classList.add('is-closing');
          sheetOpen = false;
  
          return new Promise(resolve => {
            const finish = () => {
              sheet.setAttribute('hidden','');
              sheet.classList.remove('is-closing');
  
              // Schließen:
                // kleines Timeout, dann aus dem Flow nehmen
                setTimeout(()=> scrimGlobal?.setAttribute('hidden',''), 250);
                unfreezeHeader();
                unlockBodyScroll();
                setSiblingsInert(false);
                if (sheetPrevFocus && sheetPrevFocus.focus) sheetPrevFocus.focus();
                sheetItems = null; // Draft verwerfen, wenn nicht committed
                mobile_gateSticky();
                bbTrack('sheet_close', { totalQty: Object.values(state.items || {}).reduce((a,b)=>a+b,0) });
  
                document.documentElement.classList.remove('bb--sheet-open'); // <— NEU
  
                resolve();
            };
  
            // robust gegen fehlende Events – Timeout als Fallback
            const t = setTimeout(finish, 500);
            panel?.addEventListener('animationend', () => { clearTimeout(t); finish(); }, { once:true });
          });
        }
  
        // Einfacher Fokus-Trap nur wenn Sheet offen ist
        const __bb_focusablesSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
  
        function __bb_trapFocus(e){
          if (!sheetOpen) return;
          if (e.key !== 'Tab') return;
          const nodes = panel.querySelectorAll(__bb_focusablesSelector);
          if (!nodes.length) return;
          const first = nodes[0], last = nodes[nodes.length-1];
          if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
          else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
        }
        panel?.addEventListener('keydown', __bb_trapFocus);
  
        // Für Scrim-Klick, Close-Button & ESC:
        async function mobile_closeSheet(){ await closeSheetAsync(); }
  
      openBtn?.addEventListener('click', (e)=>{ if (!isMobile()) return; e.preventDefault(); mobile_openSheet(); });
      stickyEl?.querySelector('[data-bb-open]')?.addEventListener('click', (e)=>{ if (!isMobile()) return; e.preventDefault(); mobile_openSheet(); });
      
      // SSOT: Event-Delegation auf sheet-Ebene für Close/Reset/Commit (funktioniert auch nach DOM-Änderungen)
      // WICHTIG: Delegation auf sheet statt einzelne Buttons, damit es auch funktioniert wenn Buttons noch nicht existieren
      if (sheet) {
        // Verhindere mehrfache Anhängung
        if (!sheet.dataset.bbButtonsAttached) {
          sheet.dataset.bbButtonsAttached = 'true';
          sheet.addEventListener('click', (e)=>{
            // Close Button (unterstützt beide Varianten)
            const closeBtn = e.target.closest('[data-bb-close], [data-bb-close-global]');
            if (closeBtn) {
              e.preventDefault();
              e.stopPropagation();
              mobile_closeSheet();
              return;
            }
            
            // Reset Button (unterstützt beide Varianten)
            const resetBtn = e.target.closest('[data-bb-reset], [data-bb-reset-global]');
            if (resetBtn) {
              e.preventDefault();
              e.stopPropagation();
              sheetItems = {};                         // Draft leeren
              bbTrack('reset');
              mobile_updateSheetQuantities();
              mobile_updateSheetSummary();
              updateMilestoneChips(0);                 // Chips auf "0" setzen
              return;
            }
            
            // Commit Button (unterstützt beide Varianten)
            const commitBtn = e.target.closest('[data-bb-commit], [data-bb-commit-global]');
            if (commitBtn) {
              e.preventDefault();
              e.stopPropagation();
              handleCommit();
              return;
            }
          });
        }
      }
      
      // Globaler Scrim klickbar
      scrimGlobal?.addEventListener('click', (e)=>{ e.preventDefault(); mobile_closeSheet(); });
      document.addEventListener('keydown', (e)=>{ if (e.key === 'Escape' && sheetOpen) mobile_closeSheet(); });
  
      // === Recalc der Logo-Mitte bei Resize/Rotation, solange das Sheet offen ist ===
      function bbRecalcLogoCenterIfOpen(){
        if (!sheetOpen) return;
        const header =
          document.querySelector('sticky-header') ||
          document.querySelector('.header-wrapper') ||
          document.querySelector('header[role="banner"]') ||
          document.querySelector('header');
        const inner = header?.querySelector('.header') || header;
        const logo  = header?.querySelector('.header__heading img, .header__heading-logo, .site-header__logo-image, img[alt*="Logo"]');
        if (!inner || !logo) return;
        const hr = inner.getBoundingClientRect();
        const lr = logo.getBoundingClientRect();
        const cx = (lr.left - hr.left) + (lr.width / 2);
        document.documentElement.style.setProperty('--bb-logo-x', `${Math.round(cx)}px`);
      }
      window.addEventListener('resize', bbRecalcLogoCenterIfOpen, { passive: true });
      window.addEventListener('orientationchange', () => setTimeout(bbRecalcLogoCenterIfOpen, 200), { passive: true });
  
      // iOS/Android: VisualViewport ändert sich beim Öffnen von Overlays
      if (window.visualViewport) {
        const _vvRecalc = () => bbRecalcLogoCenterIfOpen();
        visualViewport.addEventListener('resize', _vvRecalc, { passive: true });
        visualViewport.addEventListener('scroll', _vvRecalc, { passive: true });
      }
  
      // Stepper Delegation - SSOT: Event-Delegation auf sheet-Ebene (funktioniert auch nach DOM-Änderungen)
      // WICHTIG: Delegation auf sheet statt panel, damit es auch nach Template-Ersetzung funktioniert
      if (sheet) {
        // Verhindere mehrfache Anhängung
        if (!sheet.dataset.bbStepperAttached) {
          sheet.dataset.bbStepperAttached = 'true';
          sheet.addEventListener('click', (e)=>{
            if (!isMobile() || !sheetOpen) return;
            
            // Add-Button Handler (öffnet Stepper)
            const addBtn = e.target.closest('.bb-btn-add');
            if (addBtn) {
              const tile = addBtn.closest('.bb-tile');
              if (tile) {
                const plusBtn = tile.querySelector('[data-bb-plus]');
                if (plusBtn) {
                  plusBtn.click();
                  return;
                }
              }
            }
            
            // Plus/Minus Handler
            const plus  = e.target.closest('[data-bb-plus]');
            const minus = e.target.closest('[data-bb-minus]');
            if (!plus && !minus) return;
            const tile  = e.target.closest('.bb-tile'); 
            if (!tile) return;
            const vid   = String(tile.dataset.variantId);

            if (!sheetItems) sheetItems = JSON.parse(JSON.stringify(state.items || {}));
            const cur = sheetItems[vid] || 0;
            const draftTotal = Object.values(sheetItems).reduce((a,b)=>a+b,0);

            if (plus){
              if (draftTotal < maxSlots) sheetItems[vid] = cur + 1;
            } else {
              if (cur <= 1) delete sheetItems[vid];
              else sheetItems[vid] = cur - 1;
            }

            // Context7: Fail Fast - Validate immediately on change
            const totalSheetQty = Object.values(sheetItems).reduce((a,b)=>a+b,0);
            if (totalSheetQty > maxSlots) {
              console.warn('[Bundle Builder] Mobile stepper: Total quantity exceeds maximum, capping');
              sheetItems = capToMaximum(sheetItems, maxSlots);
            }

            // Nur Sheet-UI aktualisieren (Slots auf der PDP bleiben unverändert)
            mobile_updateSheetQuantities();
            mobile_updateSheetSummary();
            updateMilestoneChips(Object.values(sheetItems).reduce((a,b)=>a+b,0));
            bbTrack('qty_change', { variant_id: vid, delta: !!plus ? 1 : -1, qty: sheetItems[vid] || 0 });
          });
        }
      }
  
      // Commit Handler - SSOT: Event-Delegation auf sheet-Ebene
      // WICHTIG: Commit wird über die Event-Delegation oben (Zeile 2160) behandelt
      // Hier nur die Commit-Logik als separate Funktion für bessere Lesbarkeit
      async function handleCommit(){
        if (!isMobile()) return;

        const t0 = performance.now();
  
    // 0) Draft -> State übernehmen (Slots aktualisieren)
    if (sheetItems){
      // Context7: Defensive Programming - Validate before committing
      const totalSheetQty = Object.values(sheetItems).reduce((a,b)=>a+b,0);
      if (totalSheetQty > maxSlots) {
        console.warn('[Bundle Builder] Mobile commit: Total quantity exceeds maximum, capping to', maxSlots);
        const cappedSheetItems = capToMaximum(sheetItems, maxSlots);
        state.items = JSON.parse(JSON.stringify(cappedSheetItems));
      } else {
      state.items = JSON.parse(JSON.stringify(sheetItems));
      }
      markDirty();
      updateUI();
      bbTrack('commit', { totalQty: state.totalQty, tier_off: state.tier ? state.tier.off : 0 });
    }
  
    const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const wasOpenBefore = !!cartEl?.hasAttribute?.('open');
  
    // 1) Server-Sync starten (aber noch nicht awaiten)
    const syncP = syncCartBundleToState();
  
    // 2) Bottom-Sheet sauber schließen
    await closeSheetAsync();
  
    // 3) Jetzt sofort das Mobile-Overlay einblenden (Phase: "Zwischen Sheet und Drawer")
    bbMobileLoadingShow('Bundle wird erstellt …');
  
    // 4) Sanfte Mindestdauer gegen Flackern
    const MIN_MS = 350;
    const minP = bbDelay(MIN_MS);
  
    // 5) Auf Sync warten
    await syncP;
  
    // 6) Fast-Open: Drawer aufziehen, wenn gewünscht und schnell genug
    const elapsed = performance.now() - t0;
    if (openCartAfterAdd && elapsed <= FAST_OPEN_MS && !wasOpenBefore && !__bb_userClosedDuringSync) {
      cartEl?.open?.();
    }
  
        // 7) Overlay erst nach Mindestdauer wieder schließen (oder früher via Observer – siehe Patch 3)
        await minP;
        bbMobileLoadingHide();
      }
  
  
  
      // Express für BUNDLE: sync -> Checkout (zeigt Wallet-Optionen oben)
      document.querySelector('[data-bb-express-bundle]')?.addEventListener('click', async (e)=>{
        e.preventDefault();
  
        // 1) Wenn das Bottom-Sheet offen ist: aktuellen Draft übernehmen (wie bei Commit)
        if (typeof sheetItems !== 'undefined' && sheetItems) {
          state.items = JSON.parse(JSON.stringify(sheetItems));
          markDirty();
          updateUI();
        }
  
        // 2) Server syncen (deine bestehende Funktion)
        await syncCartBundleToState();
  
        // 3) Direkt zur Checkout-Seite (Shopify zeigt dort Express/Wallet oben)
        window.location.assign('/checkout');
      });
  
      // Sheet-Summary + Tile-Qty - Unterstützt beide Varianten (mit/ohne -global)
      const $sheetSummary = sheet?.querySelector('[data-bb-sheet-summary]');
      const $sheetCount = sheet?.querySelector('[data-bb-sheet-count], [data-bb-sheet-count-global]');
      const $sheetNext  = sheet?.querySelector('[data-bb-sheet-next], [data-bb-sheet-next-global]');
      function mobile_updateSheetSummary(){
        if (!isMobile()) return;
        const src = sheetItems || state.items;
        const q = Object.values(src).reduce((a,b)=>a+b,0);
        if ($sheetCount) $sheetCount.textContent = `${q}/${maxSlots}`;
        const next = tiers.find(t => t.qty > q);
        if ($sheetNext){
          if (!q && next){ $sheetNext.textContent = `noch ${next.qty - q} bis −${next.off}%`; }
          else if (next){ $sheetNext.textContent = `noch ${next.qty - q} bis −${next.off}%`; }
          else { $sheetNext.textContent = `max. Vorteil erreicht`; }
        }
      }
      function mobile_updateSheetQuantities(){
        if (!isMobile()) return;
        const src = sheetItems || state.items;
        sheet?.querySelectorAll('.bb-tile').forEach(tile=>{
          const vid = String(tile.dataset.variantId);
          const qty = src[vid] || 0;
          
          // Update data-qty attribute
          tile.setAttribute('data-qty', String(qty));
          
          const qtyEl = tile.querySelector('[data-bb-qty]');
          const addBtn = tile.querySelector('.bb-btn-add');
          const stepper = tile.querySelector('.bb-stepper');
          
          if (qty === 0) {
            // Initial-Zustand: Keine "0" anzeigen, nur Add-Button sichtbar
            if (qtyEl) qtyEl.textContent = '';
            if (addBtn) {
              addBtn.style.display = '';
              addBtn.removeAttribute('hidden');
            }
            if (stepper) {
              stepper.style.display = 'none';
              stepper.setAttribute('hidden', '');
            }
          } else {
            // qty > 0: Menge anzeigen, Stepper sichtbar, Add-Button versteckt
            if (qtyEl) qtyEl.textContent = String(qty);
            if (addBtn) {
              addBtn.style.display = 'none';
              addBtn.setAttribute('hidden', '');
            }
            if (stepper) {
              stepper.style.display = 'flex';
              stepper.removeAttribute('hidden');
            }
          }
        });
      }
      // Slot-Labels für Mobile (−off% auf Tier-Slots, sonst 1..10)
      function mobile_applySlotNumbers(){
        if (!isMobile()) return;
        document.querySelectorAll('.bb__slot').forEach((slot, i)=>{
          const idx = i + 1;
          const label = slot.querySelector('[data-bb-label]');
          if (!label) return;
          label.textContent = getSlotLabelText(idx); // nutzt den neuen Helper
        });
      }
  
      // Aria im Slot straffen
      function mobile_fixSlotAria(){
        if (!isMobile()) return;
        document.querySelectorAll('.bb__slot').forEach(slot=>{
          const i = slot.dataset.slot;
          slot.setAttribute('aria-label', `Slot ${i}`);
        });
      }
  
  // Initialisierung Mobile
      if (isMobile()){
        mobile_buildTicks();
        mobile_applySlotNumbers();
        mobile_updateSticky();
        mobile_gateSticky();
        mobile_fixSlotAria();
  
        // === NEU: GLOBALER EVENT LISTENER (The Remote Control) ===
        // Erlaubt anderen Sections (z.B. Featured Collection), das Sheet zu öffnen
        document.addEventListener('edm:activate-bundle', (e) => {
          // Optional: Prüfen, ob die angeforderte Variante passt (Future Proofing)
          // const requestedVariantId = e.detail?.variantId;
          
          if (!sheetOpen) {
            mobile_openSheet();
          } else {
            // Falls schon offen: Fokus oder kurzer Shake-Effekt
            const panel = document.querySelector('.bb-sheet__panel');
            if(panel) {
              panel.classList.add('bb--pulse'); 
              setTimeout(() => panel.classList.remove('bb--pulse'), 300);
            }
          }
        });
  
        // === AUTO-OPEN LOGIC (Fallback für PDP Redirects) ===
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('trigger_sheet') === 'true') {
          setTimeout(() => {
            if (!sheetOpen) {
              mobile_openSheet();
              try {
                const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                window.history.replaceState({path: newUrl}, '', newUrl);
              } catch(e) {}
            }
          }, 300); 
        }
      }
  
      /* ================== MOBILE PRELOADING (Performance) ================== */
      /**
       * Pre-loads sheet images during browser idle time to prevent jank on first open
       * Context7: Performance Optimization - Pre-warms resources without blocking LCP
       * 
       * Uses requestIdleCallback to wait for browser idle, then preloads first 6-8 images
       * in the bottom sheet. This ensures smooth 60fps animation on first open.
       */
      function mobile_preloadSheetResources(){
        if (!isMobile()) return;
        
        const sheet = document.getElementById('bb-sheet');
        if (!sheet) return;
        
        // Find first 6-8 images in the sheet grid
        const images = Array.from(sheet.querySelectorAll('.bb-sheet__grid .bb-tile__imgwrap img'));
        const preloadLimit = Math.min(8, images.length);
        
        if (preloadLimit === 0) return;
        
        // Preload images: change loading attribute and trigger decode
        for (let i = 0; i < preloadLimit; i++) {
          const img = images[i];
          if (!img) continue;
          
          // Change from lazy to eager loading
          if (img.loading === 'lazy') {
            img.loading = 'eager';
          }
          
          // Trigger decode if available (non-blocking)
          // Context7: Error Handling - decode() can throw if image fails to load (e.g. 404)
          // Silently catch errors - image will still load normally via browser fallback
          if (img.decode && typeof img.decode === 'function') {
            img.decode().catch(() => {
              // Silently ignore decode errors (image will still load normally)
            });
          }
        }
        
        // Optional: Layer promotion for sheet panel (GPU acceleration)
        // Context7: Performance - GPU layer promotion for smooth animations
        const panel = sheet.querySelector('.bb-sheet__panel');
        if (panel) {
          // Set will-change to promote to GPU layer (improves animation smoothness)
          panel.style.willChange = 'transform';
          
          // Memory Management Note:
          // Keeping will-change active is safe for a single sheet on modern devices.
          // On extremely low-end Android devices with very low RAM, keeping too many
          // GPU layers can cause crashes. If you experience crashes on old phones,
          // uncomment the timeout below to free GPU resources after 5s:
          // setTimeout(() => {
          //   panel.style.willChange = 'auto';
          // }, 5000);
        }
      }
      
      // Schedule preloading during idle time (non-blocking)
      // Only run on mobile to avoid unnecessary work on desktop
      if (isMobile()) {
        const schedulePreload = () => {
          if ('requestIdleCallback' in window) {
            requestIdleCallback(mobile_preloadSheetResources, { timeout: 2000 });
          } else {
            // Fallback for browsers without requestIdleCallback
            setTimeout(mobile_preloadSheetResources, 1000);
          }
        };
        
        // Wait for DOM to be fully ready before scheduling
        if (document.readyState === 'complete') {
          schedulePreload();
        } else {
          window.addEventListener('load', schedulePreload, { once: true });
        }
      }
    });
    
    // ===== Desktop Modal (Landing Page One-Click) =====
    
    // --- EXPERT FIX II: IMAGE NORMALIZER ---
    // Normalisiert Bild-URLs aus verschiedenen Shopify-Datenquellen
    // Unterstützt: Liquid JSON, Ajax API, verschiedene Objekt-Strukturen
    function normalizeImageUrl(variant, product = null) {
      let imgSrc = '';
      
      // PRIORITY 1: Variant.image (String) - Liquid JSON Format
      if (variant.image) {
        if (typeof variant.image === 'string') {
          imgSrc = variant.image;
        } else if (variant.image.src) {
          imgSrc = variant.image.src;
        } else if (variant.image.url) {
          imgSrc = variant.image.url;
        }
      }
      
      // PRIORITY 2: Variant.featured_image (Objekt) - Ajax API Format
      if (!imgSrc && variant.featured_image) {
        if (typeof variant.featured_image === 'string') {
          imgSrc = variant.featured_image;
        } else if (variant.featured_image.src) {
          imgSrc = variant.featured_image.src;
        } else if (variant.featured_image.url) {
          imgSrc = variant.featured_image.url;
        }
      }
      
      // PRIORITY 3: Product.featured_image (Fallback) - Ajax API Format
      if (!imgSrc && product) {
        if (product.featured_image) {
          if (typeof product.featured_image === 'string') {
            imgSrc = product.featured_image;
          } else if (product.featured_image.src) {
            imgSrc = product.featured_image.src;
          } else if (product.featured_image.url) {
            imgSrc = product.featured_image.url;
          }
        }
      }
      
      // PRIORITY 4: Product.image (Fallback) - Alternative Ajax API Format
      if (!imgSrc && product && product.image) {
        if (typeof product.image === 'string') {
          imgSrc = product.image;
        }
      }
      
      // HTTPS-Erzwingung und Protokoll-Normalisierung
      if (imgSrc) {
        // HTTP zu HTTPS
        if (imgSrc.startsWith('http:')) {
          imgSrc = imgSrc.replace('http:', 'https:');
        }
        // Protocol-relative zu HTTPS
        if (imgSrc.startsWith('//')) {
          imgSrc = 'https:' + imgSrc;
        }
      }
      
      // PRIORITY 5: Placeholder (wenn alles fehlschlägt)
      if (!imgSrc) {
        imgSrc = 'https://cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';
        console.warn('[Bundle Builder] No image found for variant, using placeholder', {
          variantId: variant.id,
          variantTitle: variant.title,
          hasVariantImage: !!variant.image,
          hasVariantFeaturedImage: !!variant.featured_image,
          hasProductImage: product ? !!product.featured_image : false
        });
      }
      
      return imgSrc;
    }
    // ---------------------------------------
    
    // ===== Global-Version (ohne #bundle-builder, für Landing Pages) =====
    function initDesktopModal() {
      try {
        // WICHTIG: Diese Funktion ist für Global-Version
        // Nutzt NICHT 'el' aus PDP-Scope
        
        const modal = document.getElementById('bb-modal-global') || document.getElementById('bb-modal');
        if (!modal) {
          console.log('[Bundle Builder] No modal found, skipping initialization');
          return;
        }

        // --- EXPERT FIX I: TELEPORTATION ---
        // Wir bewegen das Modal aus der Section direkt in den Body-Root.
        // Das löst alle z-index und overflow Probleme sofort.
        if (modal.parentElement !== document.body) {
          console.log('[Bundle Builder] Teleporting modal to body for correct positioning');
          document.body.appendChild(modal);
        }
        // -----------------------------------
        
        // Defensive: Definiere fehlende Variablen mit Defaults
        const defaultTiers = [{qty:3,off:10},{qty:6,off:20},{qty:10,off:25}];
        let tiers = defaultTiers;
        const maxSlots = 10;
        
        // Defensive: bbTrack-Fallback
        const bbTrack = window.bbTrack || function() { 
          console.log('[Bundle Builder] Track:', arguments); 
        };
        
        // Helper: Get Tier for Quantity
        function getTierForQty(qty, tiersArray) {
          if (!tiersArray || tiersArray.length === 0) return null;
          let bestTier = null;
          for (let i = tiersArray.length - 1; i >= 0; i--) {
            if (qty >= tiersArray[i].qty) {
              bestTier = tiersArray[i];
              break;
            }
          }
          return bestTier;
        }
        
        // Defensive: DOM-Elemente mit Null-Checks
        const panel = modal?.querySelector('.bb-modal__panel');
        if (!panel) {
          console.warn('[Bundle Builder] Modal panel not found');
          return;
        }
        
        // Unterstützt sowohl globale als auch legacy Selektoren
        const closeBtn = modal?.querySelector('[data-bb-modal-close-global]') || modal?.querySelector('[data-bb-modal-close]');
        const commitBtn = modal?.querySelector('[data-bb-commit-modal-global]') || modal?.querySelector('[data-bb-commit]');
        const grid = modal?.querySelector('#bb-modal-global-grid') || modal?.querySelector('#bb-modal-grid');
        
        if (!grid) {
          console.warn('[Bundle Builder] Modal grid not found');
          return;
        }
      
      let modalOpen = false;
      let modalItems = {}; // Draft state for modal
      
      // Close handlers
      const closeModal = () => {
        if (!modalOpen) return;
        modal.classList.remove('is-open');
        modal.setAttribute('hidden', '');
        modalOpen = false;
        document.documentElement.classList.remove('bb--modal-open');
        document.body.style.overflow = '';
        // Clear draft
        modalItems = {};
      };
      
      closeBtn?.addEventListener('click', closeModal);
      modal.addEventListener('click', (e) => {
        if (e.target === modal) closeModal();
      });
      
      // ESC key handler
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modalOpen) closeModal();
      });
      
      // Stepper delegation (reuse mobile logic)
      panel?.addEventListener('click', (e) => {
        const plus = e.target.closest('[data-bb-plus]');
        const minus = e.target.closest('[data-bb-minus]');
        if (!plus && !minus) return;
        const tile = e.target.closest('.bb-tile');
        if (!tile) return;
        const vid = String(tile.dataset.variantId);
        
        if (!modalItems) modalItems = {};
        const cur = modalItems[vid] || 0;
        const draftTotal = Object.values(modalItems).reduce((a, b) => a + b, 0);
        
        if (plus) {
          if (draftTotal < maxSlots) modalItems[vid] = cur + 1;
        } else {
          if (cur <= 1) delete modalItems[vid];
          else modalItems[vid] = cur - 1;
        }
        
        // Update UI
        updateModalQuantities();
        updateModalMilestones();
        bbTrack('qty_change', { variant_id: vid, delta: !!plus ? 1 : -1, qty: modalItems[vid] || 0 });
      });
      
      // Update quantities in modal
      function updateModalQuantities() {
        grid?.querySelectorAll('.bb-tile').forEach(tile => {
          const vid = String(tile.dataset.variantId);
          const qtyEl = tile.querySelector('[data-bb-qty]');
          if (qtyEl) qtyEl.textContent = String(modalItems[vid] || 0);
        });
      }
      
      // Update milestone chips
      function updateModalMilestones() {
        const total = Object.values(modalItems).reduce((a, b) => a + b, 0);
        const tier = getTierForQty(total, tiers);
        modal?.querySelectorAll('.bb-chip').forEach(chip => {
          const m = parseInt(chip.dataset.m || '0', 10);
          if (m === 0) {
            chip.classList.toggle('is-active', total === 0);
          } else {
            chip.classList.toggle('is-active', tier && tier.qty === m);
          }
        });
      }
      
        // Commit handler für Global-Version (ohne PDP state)
      commitBtn?.addEventListener('click', async () => {
        if (!modalOpen) return;
        
          // Prüfe ob Items vorhanden
          if (Object.keys(modalItems).length === 0) {
            alert('Bitte wählen Sie mindestens einen Booster aus.');
            return;
          }
          
          // Konvertiere modalItems zu Cart-Format
          const items = Object.entries(modalItems).map(([vid, qty]) => ({
            id: parseInt(vid, 10),
            quantity: qty
          }));
          
          try {
            // Direkter Cart-Add (ohne state)
            const cartRoute = window.Shopify?.routes?.root 
              ? window.Shopify.routes.root + 'cart/add.js'
              : '/cart/add.js';
            const response = await fetch(cartRoute, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ items: items })
            });
            
            if (!response.ok) {
              const error = await response.json();
              throw new Error(error.description || 'Fehler beim Hinzufügen zum Warenkorb');
            }
            
            // Update Cart Drawer
          const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              const sectionsRoute = window.Shopify?.routes?.root
                ? window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble'
                : '/?sections=cart-drawer,cart-icon-bubble';
              fetch(sectionsRoute)
                .then(r => r.json())
                .then(sections => {
                  if (cartDrawer.renderContents) {
                    cartDrawer.renderContents(sections);
                  }
                });
            } else {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            }
            
            closeModal();
            
            // Open cart drawer
            if (cartDrawer) {
              setTimeout(() => {
                if (typeof cartDrawer.open === 'function') {
                  cartDrawer.open();
                } else {
                  document.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
                }
              }, 300);
            }
            
          } catch (error) {
            console.error('[Global Bundle Builder] Error adding to cart:', error);
            alert(error.message || 'Fehler beim Hinzufügen zum Warenkorb');
        }
      });
      
      // Helper: Create product tile element
      function createProductTile(variant, product = null) {
        const tile = document.createElement('div');
        tile.className = 'bb-tile';
        if (!variant.available) tile.classList.add('is-disabled');
        tile.setAttribute('data-variant-id', variant.id);
        tile.setAttribute('role', 'listitem');
        
        const imgWrap = document.createElement('div');
        imgWrap.className = 'bb-tile__imgwrap';
        
        // Nutze Image Normalizer für robuste Bild-Extraktion
        const imgSrc = normalizeImageUrl(variant, product);
        
        if (imgSrc) {
          const img = document.createElement('img');
          img.src = imgSrc;
          img.alt = variant.title || '';
          img.loading = 'lazy';
          img.decoding = 'async';
          imgWrap.appendChild(img);
        }
        
        const stepper = document.createElement('div');
        stepper.className = 'bb-stepper';
        stepper.setAttribute('aria-label', 'Menge anpassen');
        
        const minusBtn = document.createElement('button');
        minusBtn.className = 'bb-stepper__btn bb-stepper__minus';
        minusBtn.type = 'button';
        minusBtn.setAttribute('data-bb-minus', '');
        minusBtn.setAttribute('aria-label', 'Einen entfernen');
        minusBtn.textContent = '−';
        
        const qtyOutput = document.createElement('output');
        qtyOutput.className = 'bb-stepper__qty';
        qtyOutput.setAttribute('data-bb-qty', '');
        qtyOutput.textContent = '0';
        
        const plusBtn = document.createElement('button');
        plusBtn.className = 'bb-stepper__btn bb-stepper__plus';
        plusBtn.type = 'button';
        plusBtn.setAttribute('data-bb-plus', '');
        plusBtn.setAttribute('aria-label', 'Einen hinzufügen');
        plusBtn.textContent = '+';
        
        stepper.appendChild(minusBtn);
        stepper.appendChild(qtyOutput);
        stepper.appendChild(plusBtn);
        
        tile.appendChild(imgWrap);
        tile.appendChild(stepper);
        
        return tile;
      }
      
      // Helper: Get tier for quantity
        function getTierForQtyLocal(qty, tiersArray) {
          if (!tiersArray || tiersArray.length === 0) return null;
          let bestTier = null;
          for (let i = tiersArray.length - 1; i >= 0; i--) {
            if (qty >= tiersArray[i].qty) {
              bestTier = tiersArray[i];
              break;
            }
          }
          return bestTier;
      }
      
      // Expose open function globally
        window.openDesktopModal = (productData, productTiers = null, product = null) => {
        if (modalOpen || !grid) return;
        
        // Use provided tiers or default
        const modalTiers = productTiers || [{qty:3,off:10},{qty:6,off:20},{qty:10,off:25}];
        
        // Populate milestones (unterstützt globale und legacy Selektoren)
        const milestonesContainer = modal.querySelector('[data-bb-modal-milestones-global]') || modal.querySelector('[data-bb-modal-milestones]');
        if (milestonesContainer) {
          milestonesContainer.innerHTML = '<span class="bb-chip" data-m="0">0%</span>';
          modalTiers.forEach(t => {
            const chip = document.createElement('span');
            chip.className = 'bb-chip';
            chip.setAttribute('data-m', t.qty);
            chip.textContent = `−${t.off}%`;
            milestonesContainer.appendChild(chip);
          });
        }
        
        // Limit to 10 items (5×2 grid)
        const limitedData = productData.slice(0, 10);
        
        // Populate grid
        grid.innerHTML = '';
        limitedData.forEach((variant) => {
          const tile = createProductTile(variant, product);
          grid.appendChild(tile);
        });
        
        // Reset draft
        modalItems = {};
        updateModalQuantities();
        
        // Update milestones with local tiers
        function updateModalMilestonesLocal() {
          const total = Object.values(modalItems).reduce((a, b) => a + b, 0);
          const tier = getTierForQtyLocal(total, modalTiers);
          modal?.querySelectorAll('.bb-chip').forEach(chip => {
            const m = parseInt(chip.dataset.m || '0', 10);
            if (m === 0) {
              chip.classList.toggle('is-active', total === 0);
            } else {
              chip.classList.toggle('is-active', tier && tier.qty === m);
            }
          });
        }
        
        // Override updateModalMilestones to use local tiers
        const originalUpdateModalMilestones = updateModalMilestones;
        updateModalMilestones = updateModalMilestonesLocal;
        updateModalMilestonesLocal();
        
        // Update stepper handler to use local tiers
        const maxSlotsLocal = 10;
        panel?.removeEventListener('click', panel._modalClickHandler);
        panel._modalClickHandler = (e) => {
          const plus = e.target.closest('[data-bb-plus]');
          const minus = e.target.closest('[data-bb-minus]');
          if (!plus && !minus) return;
          const tile = e.target.closest('.bb-tile');
          if (!tile) return;
          const vid = String(tile.dataset.variantId);
          
          if (!modalItems) modalItems = {};
          const cur = modalItems[vid] || 0;
          const draftTotal = Object.values(modalItems).reduce((a, b) => a + b, 0);
          
          if (plus) {
            if (draftTotal < maxSlotsLocal) modalItems[vid] = cur + 1;
          } else {
            if (cur <= 1) delete modalItems[vid];
            else modalItems[vid] = cur - 1;
          }
          
          updateModalQuantities();
          updateModalMilestonesLocal();
        };
        panel?.addEventListener('click', panel._modalClickHandler);
        
        // Override commit handler for standalone modal
        commitBtn?.removeEventListener('click', commitBtn._originalCommitHandler);
        commitBtn._originalCommitHandler = commitBtn.onclick;
        commitBtn.onclick = null;
        
        commitBtn._standaloneCommitHandler = async () => {
          if (!modalOpen || Object.keys(modalItems).length === 0) {
            if (Object.keys(modalItems).length === 0) {
              alert('Bitte wählen Sie mindestens einen Booster aus.');
            }
            return;
          }
          
          // Add to cart via AJAX
          const items = Object.entries(modalItems).map(([vid, qty]) => ({
            id: parseInt(vid, 10),
            quantity: qty
          }));
          
          try {
            // Robust cart URL construction
            const cartRoute = window.Shopify?.routes?.root 
              ? window.Shopify.routes.root + 'cart/add.js'
              : '/cart/add.js';
            const response = await fetch(cartRoute, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ items: items })
            });
            
            if (!response.ok) {
              const error = await response.json();
              throw new Error(error.description || 'Fehler beim Hinzufügen zum Warenkorb');
            }
            
            // Update cart drawer
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              // Fetch sections for cart drawer
              const sectionsRoute = window.Shopify?.routes?.root
                ? window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble'
                : '/?sections=cart-drawer,cart-icon-bubble';
              fetch(sectionsRoute)
                .then(r => r.json())
                .then(sections => {
                  if (cartDrawer.renderContents) {
                    cartDrawer.renderContents(sections);
                  }
                });
            } else {
              // Fallback: Trigger cart refresh event
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            }
            
            // Close modal
            closeModal();
            
            // Open cart drawer
            if (cartDrawer) {
              setTimeout(() => {
                if (typeof cartDrawer.open === 'function') {
                  cartDrawer.open();
                } else {
                  document.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
                }
              }, 300);
            }
            
          } catch (error) {
            console.error('[Desktop Modal] Error adding to cart:', error);
            alert(error.message || 'Fehler beim Hinzufügen zum Warenkorb');
          }
        };
        
        commitBtn?.addEventListener('click', commitBtn._standaloneCommitHandler);
        
        // Open modal
        modal.removeAttribute('hidden');
        requestAnimationFrame(() => {
          modal.classList.add('is-open');
          modalOpen = true;
          document.documentElement.classList.add('bb--modal-open');
          document.body.style.overflow = 'hidden';
          
          // Focus trap
          closeBtn?.focus();
        });
      };
        
      } catch (error) {
        console.error('[Bundle Builder] Error initializing desktop modal:', error);
        // Graceful degradation: Stelle sicher, dass Event-Listener trotzdem funktionieren
      }
    }
    
    // Initialize on DOM ready
    onReady(initDesktopModal);
    
    // ===== One-Click Handler Detection =====
    
    function attachOneClickHandlers() {
      // Defensive: Definiere buttons (falls nicht vorhanden)
      const buttons = document.querySelectorAll('[data-one-click="true"]');
      
      // Method 1: Data attribute on buttons
      buttons.forEach(btn => {
        btn.addEventListener('click', async (e) => {
          e.preventDefault();
          const productId = btn.dataset.productId || btn.closest('[data-product-id]')?.dataset.productId;
          const productHandle = btn.dataset.productHandle || btn.closest('[data-product-handle]')?.dataset.productHandle; // NEU
          
          if ((productId || productHandle) && window.openDesktopModal && window.innerWidth > 989) {
            try {
              // Nutze Handle (mit ID-Fallback)
              const productIdentifier = productHandle || productId;
              
              // Robust Shopify routes handling
              let shopifyRoot = '';
              if (window.Shopify?.routes?.root) {
                shopifyRoot = window.Shopify.routes.root;
              } else if (window.Shopify?.routes) {
                shopifyRoot = window.Shopify.routes.root || '';
              }
              // Ensure trailing slash if root exists
              if (shopifyRoot && !shopifyRoot.endsWith('/')) {
                shopifyRoot += '/';
              }
              
              // WICHTIG: Shopify unterstützt nur /products/{handle}.js, nicht /products/{id}.js
              let productUrl;
              if (productHandle) {
                // Best Case: Handle verfügbar
                productUrl = shopifyRoot + `products/${productHandle}.js`;
              } else if (productId) {
                // Fallback: Versuche ID (wird wahrscheinlich 404 geben)
                console.warn('[Bundle Builder] No handle available, using ID (may fail):', productId);
                productUrl = shopifyRoot + `products/${productId}.js`;
              } else {
                throw new Error('No product identifier (handle or ID) provided');
              }
              
              const response = await fetch(productUrl);
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              const product = await response.json();
              const variants = product.variants.map(v => ({
                id: v.id,
                title: v.title,
                price: v.price,
                available: v.available,
                image: v.featured_image?.src || product.featured_image?.src || ''
              }));
              
              // Extract tiers from product
              const defaultTiers = [{qty:3,off:10},{qty:6,off:20},{qty:10,off:25}];
              let tiers = defaultTiers;
              if (product.metafields?.custom?.bundle_tiers?.value) {
                try {
                  tiers = typeof product.metafields.custom.bundle_tiers.value === 'string' 
                    ? JSON.parse(product.metafields.custom.bundle_tiers.value)
                    : product.metafields.custom.bundle_tiers.value;
                } catch(e) {
                  tiers = defaultTiers;
                }
              }
              
              window.openDesktopModal(variants, tiers);
            } catch (error) {
              console.error('[Bundle Builder] Error fetching product:', error);
            }
          }
        });
      });
      
      // Method 2: Specific class selector
      document.querySelectorAll('.bb__open-desktop-modal').forEach(btn => {
        btn.addEventListener('click', async (e) => {
          e.preventDefault();
          if (window.innerWidth <= 989) return; // Mobile: use bottom sheet
          
          const productId = btn.dataset.productId || btn.closest('[data-product-id]')?.dataset.productId;
          const productHandle = btn.dataset.productHandle || btn.closest('[data-product-handle]')?.dataset.productHandle; // NEU
          
          if ((productId || productHandle) && window.openDesktopModal) {
            try {
              // Nutze Handle (mit ID-Fallback)
              const productIdentifier = productHandle || productId;
              
              let shopifyRoot = window.Shopify?.routes?.root || '';
              if (shopifyRoot && !shopifyRoot.endsWith('/')) {
                shopifyRoot += '/';
              }
              
              // WICHTIG: Shopify unterstützt nur /products/{handle}.js, nicht /products/{id}.js
              let productUrl;
              if (productHandle) {
                // Best Case: Handle verfügbar
                productUrl = shopifyRoot + `products/${productHandle}.js`;
              } else if (productId) {
                // Fallback: Versuche ID (wird wahrscheinlich 404 geben)
                console.warn('[Bundle Builder] No handle available, using ID (may fail):', productId);
                productUrl = shopifyRoot + `products/${productId}.js`;
              } else {
                throw new Error('No product identifier (handle or ID) provided');
              }
              
              const response = await fetch(productUrl);
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              const product = await response.json();
              const variants = product.variants.map(v => ({
                id: v.id,
                title: v.title,
                price: v.price,
                available: v.available,
                image: v.featured_image?.src || product.featured_image?.src || ''
              }));
              
              // Extract tiers from product
              const defaultTiers = [{qty:3,off:10},{qty:6,off:20},{qty:10,off:25}];
              let tiers = defaultTiers;
              if (product.metafields?.custom?.bundle_tiers?.value) {
                try {
                  tiers = typeof product.metafields.custom.bundle_tiers.value === 'string' 
                    ? JSON.parse(product.metafields.custom.bundle_tiers.value)
                    : product.metafields.custom.bundle_tiers.value;
                } catch(e) {
                  tiers = defaultTiers;
                }
              }
              
              window.openDesktopModal(variants, tiers);
            } catch (error) {
              console.error('[Bundle Builder] Error fetching product:', error);
            }
          }
        });
      });
    }
    
    onReady(attachOneClickHandlers);
    
    // ===== Global Bundle Builder Initialization =====
    // Unterstützt sowohl PDP (#bundle-builder) als auch Landing Page (globale Komponente)
    
    function initGlobalBundleBuilder() {
      // Idempotente Initialisierung: Prüfe ob bereits initialisiert
      if (document._bbGlobalInitialized) {
        console.log('[Bundle Builder] Already initialized, skipping...');
        return;
      }
      
      console.log('[Bundle Builder] Initializing global component...', {
        triggers: document.querySelectorAll('[data-bb-trigger]').length,
        legacyTriggers: document.querySelectorAll('[data-open-mobile-sheet="true"], [data-one-click="true"]').length,
        globalSheet: !!document.getElementById('bb-sheet-global'),
        globalModal: !!document.getElementById('bb-modal-global')
      });
      
      // Prüfe ob globale Komponente benötigt wird
      const globalSheet = document.getElementById('bb-sheet-global');
      const globalModal = document.getElementById('bb-modal-global');
      
      if (!globalSheet && !globalModal) {
        console.log('[Bundle Builder] No global components found, skipping initialization');
        return;
      }
      
      document._bbGlobalInitialized = true;
      
      // Initialisiere globale Bottom Sheet (falls vorhanden)
      initGlobalBottomSheet();
      
      // Initialisiere globales Modal (falls vorhanden)
      initGlobalModal();
      
      // Event-Delegation auf document-Ebene (nur einmal registrieren)
      if (!document._bbEventDelegationSetup) {
        document.addEventListener('click', (e) => {
          // PRIORITY 1: Suche nach spezifischen Booster-Triggers
          // Unterstützt sowohl "modal" als auch "sheet" als Wert
          const trigger = e.target.closest('[data-bb-trigger="modal"], [data-bb-trigger="sheet"], [data-bb-trigger="true"]');
          
          if (trigger) {
            // HARD BYPASS: Verhindere ALLE Standard-Aktionen
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation(); // Verhindert auch andere Listener
            
            const productId = trigger.dataset.productId;
            const productHandle = trigger.dataset.productHandle; // FIXED: Handle explizit extrahieren
            const triggerType = trigger.dataset.bbTrigger; // 'modal', 'sheet', oder 'true'
            
            console.log('[Bundle Builder] Booster trigger clicked', {
              trigger: trigger,
              productId: productId,
              productHandle: productHandle, // FIXED: Handle im Log
              triggerType: triggerType,
              isMobile: window.innerWidth <= 989
            });
            
            if (!productId && !productHandle) {
              console.error('[Bundle Builder] No product ID or handle found on trigger', trigger);
              return;
            }
            
            // Warnung wenn Handle fehlt aber ID vorhanden ist (defensive)
            if (!productHandle && productId) {
              console.warn('[Bundle Builder] Handle missing, using ID fallback. This may cause 404 errors. Product ID:', productId);
            }
            
            // PRIORITY 2: Mobile/Desktop-Weiche
            const isMobile = window.innerWidth <= 989;
            
            // PRIORITY 3: Trigger-Type-basierte Entscheidung
            if (triggerType === 'sheet' || (isMobile && triggerType !== 'modal')) {
              // Mobile: Bottom Sheet öffnen
              // FIXED: Übergebe beide Werte (ID für Template-Lookup, Handle für API)
              if (window.openGlobalBottomSheet) {
                console.log('[Bundle Builder] Opening global bottom sheet for product:', productId, 'handle:', productHandle);
                window.openGlobalBottomSheet(productId, productHandle);
              } else {
                console.error('[Bundle Builder] window.openGlobalBottomSheet not available');
                // Defensive: Versuche Initialisierung
                if (typeof initGlobalBottomSheet === 'function') {
                  initGlobalBottomSheet();
                  setTimeout(() => {
                    if (window.openGlobalBottomSheet) {
                      window.openGlobalBottomSheet(productId, productHandle);
                    } else {
                      alert('Fehler: Bottom Sheet konnte nicht initialisiert werden.');
                    }
                  }, 100);
                } else {
                  alert('Fehler: Bottom Sheet konnte nicht initialisiert werden.');
                }
              }
            } else if (triggerType === 'modal' || (!isMobile && triggerType === 'true')) {
              // Desktop: Modal öffnen
              if (window.openDesktopModal || typeof handleGlobalTrigger === 'function') {
                // Nutze handleGlobalTrigger für konsistente Logik
                try {
                  handleGlobalTrigger.call(trigger, e);
                } catch (error) {
                  console.error('[Bundle Builder] Error in handleGlobalTrigger:', error);
                  // Fallback: Direkter Aufruf
                  if (typeof loadProductForModal === 'function') {
                    loadProductForModal(productId).then(({variants, tiers, product}) => {
                      if (window.openDesktopModal) {
                        window.openDesktopModal(variants, tiers, product);
                      } else {
                        console.error('[Bundle Builder] window.openDesktopModal not available');
                        alert('Fehler: Modal konnte nicht geöffnet werden.');
                      }
                    }).catch(error => {
                      console.error('[Bundle Builder] Error loading product for modal:', error);
                      alert('Fehler beim Laden der Produktdaten.');
                    });
                  } else {
                    alert('Fehler: Modal konnte nicht geöffnet werden.');
                  }
                }
              } else {
                console.error('[Bundle Builder] window.openDesktopModal not available');
                alert('Fehler: Modal konnte nicht geöffnet werden.');
              }
            }
            
            return; // WICHTIG: Verhindere weitere Event-Propagation
          }
          
          // PRIORITY 4: Legacy-Trigger (für Rückwärtskompatibilität)
          const legacyTrigger = e.target.closest('[data-open-mobile-sheet="true"], [data-one-click="true"]');
          if (legacyTrigger && !legacyTrigger.hasAttribute('data-bb-trigger')) {
            console.log('[Bundle Builder] Legacy trigger clicked', {
              trigger: legacyTrigger,
              productId: legacyTrigger.dataset.productId
            });
            e.preventDefault();
            e.stopPropagation();
            try {
              handleLegacyTrigger.call(legacyTrigger, e);
            } catch (error) {
              console.error('[Bundle Builder] Error handling legacy trigger:', error);
            }
            return;
          }
        }, { capture: true, passive: false }); // CAPTURE: true für frühere Event-Interception
        
        document._bbEventDelegationSetup = true;
        console.log('[Bundle Builder] Event delegation set up successfully with capture phase');
      }
    }
    
    /* ================== SSOT: UNIFIED BOTTOM SHEET CONTROLLER ================== */
    /**
     * BottomSheetController - Single Source of Truth für beide Sheets (PDP und LP)
     * Unterstützt sowohl 'bb-sheet' (PDP) als auch 'bb-sheet-global' (LP)
     * Event-Delegation auf sheet-Ebene für Robustheit nach DOM-Änderungen
     */
    class BottomSheetController {
      constructor(sheetId, options = {}) {
        this.sheetId = sheetId;
        this.sheet = document.getElementById(sheetId);
        if (!this.sheet) {
          console.warn(`[Bundle Builder] Sheet ${sheetId} not found`);
          return;
        }
        
        // Options
        this.isPDP = sheetId === 'bb-sheet';
        this.maxSlots = options.maxSlots || 10;
        this.tiers = options.tiers || [];
        this.onStateChange = options.onStateChange || (() => {});
        this.onCommit = options.onCommit || (() => {});
        
        // State
        this.sheetOpen = false;
        this.sheetItems = {};
        this.sheetPrevFocus = null;
        
        // DOM Elements (werden dynamisch gesucht, da sie sich ändern können)
        this.scrim = document.getElementById(this.isPDP ? 'bb-scrim' : 'bb-scrim-global');
        this.grid = this.sheet.querySelector(`#${sheetId}-grid`) || this.sheet.querySelector('.bb-sheet__grid');
        this.panel = this.sheet.querySelector('.bb-sheet__panel');
        
        // Initialize
        this.attachEventHandlers();
      }
      
      /**
       * Attach all event handlers using delegation on sheet level
       * This ensures handlers work even after DOM changes (template replacement)
       */
      attachEventHandlers() {
        if (!this.sheet || this.sheet.dataset.bbControllerAttached === 'true') return;
        this.sheet.dataset.bbControllerAttached = 'true';
        
        // Unified event delegation for all interactions
        this.sheet.addEventListener('click', (e) => this.handleClick(e));
        
        // Scrim click
        if (this.scrim) {
          this.scrim.addEventListener('click', (e) => {
            e.preventDefault();
            this.close();
          });
        }
        
        // ESC key handler
        const escHandler = (e) => {
          if (e.key === 'Escape' && this.sheetOpen && this.sheet.classList.contains('is-open')) {
            this.close();
          }
        };
        document.addEventListener('keydown', escHandler);
        this.sheet._bbEscHandler = escHandler;
      }
      
      /**
       * Handle all click events via delegation
       */
      handleClick(e) {
        // Close Button
        const closeBtn = e.target.closest('[data-bb-close], [data-bb-close-global]');
        if (closeBtn) {
          e.preventDefault();
          e.stopPropagation();
          this.close();
          return;
        }
        
        // Reset Button
        const resetBtn = e.target.closest('[data-bb-reset], [data-bb-reset-global]');
        if (resetBtn) {
          e.preventDefault();
          e.stopPropagation();
          this.reset();
          return;
        }
        
        // Commit Button
        const commitBtn = e.target.closest('[data-bb-commit], [data-bb-commit-global]');
        if (commitBtn) {
          e.preventDefault();
          e.stopPropagation();
          this.commit();
          return;
        }
        
        // Add Button (opens stepper)
        const addBtn = e.target.closest('.bb-btn-add');
        if (addBtn) {
          const tile = addBtn.closest('.bb-tile');
          if (tile) {
            const plusBtn = tile.querySelector('[data-bb-plus]');
            if (plusBtn) plusBtn.click();
          }
          return;
        }
        
        // Plus/Minus (Stepper)
        const plus = e.target.closest('[data-bb-plus]');
        const minus = e.target.closest('[data-bb-minus]');
        if (plus || minus) {
          const tile = e.target.closest('.bb-tile');
          if (!tile) return;
          const vid = String(tile.dataset.variantId);
          
          const cur = this.sheetItems[vid] || 0;
          const total = Object.values(this.sheetItems).reduce((a, b) => a + b, 0);
          
          if (plus) {
            if (total < this.maxSlots) this.sheetItems[vid] = cur + 1;
          } else {
            if (cur <= 1) delete this.sheetItems[vid];
            else this.sheetItems[vid] = cur - 1;
          }
          
          this.updateQuantities();
          this.updateSummary();
          this.onStateChange(this.sheetItems);
          return;
        }
        
        // Sheet backdrop click
        if (e.target === this.sheet) {
          this.close();
        }
      }
      
      /**
       * Open the sheet
       */
      open() {
        if (this.sheetOpen || !this.sheet) return;
        // Implementation will be added per sheet type
      }
      
      /**
       * Close the sheet
       */
      close() {
        if (!this.sheetOpen || !this.sheet) return;
        // Implementation will be added per sheet type
      }
      
      /**
       * Reset all quantities
       */
      reset() {
        this.sheetItems = {};
        this.updateQuantities();
        this.updateSummary();
        this.onStateChange(this.sheetItems);
      }
      
      /**
       * Update tile quantities in UI
       */
      updateQuantities() {
        if (!this.grid) return;
        this.grid.querySelectorAll('.bb-tile').forEach(tile => {
          const vid = String(tile.dataset.variantId);
          const qty = this.sheetItems[vid] || 0;
          
          tile.setAttribute('data-qty', String(qty));
          
          const qtyEl = tile.querySelector('[data-bb-qty]');
          const addBtn = tile.querySelector('.bb-btn-add');
          const stepper = tile.querySelector('.bb-stepper');
          
          if (qty === 0) {
            if (qtyEl) qtyEl.textContent = '';
            if (addBtn) {
              addBtn.style.display = '';
              addBtn.removeAttribute('hidden');
            }
            if (stepper) {
              stepper.style.display = 'none';
              stepper.setAttribute('hidden', '');
            }
          } else {
            if (qtyEl) qtyEl.textContent = String(qty);
            if (addBtn) {
              addBtn.style.display = 'none';
              addBtn.setAttribute('hidden', '');
            }
            if (stepper) {
              stepper.style.display = 'flex';
              stepper.removeAttribute('hidden');
            }
          }
        });
      }
      
      /**
       * Update summary (count/next tier)
       */
      updateSummary() {
        const total = Object.values(this.sheetItems).reduce((a, b) => a + b, 0);
        const countEl = this.sheet.querySelector('[data-bb-sheet-count], [data-bb-sheet-count-global]');
        const nextEl = this.sheet.querySelector('[data-bb-sheet-next], [data-bb-sheet-next-global]');
        
        if (countEl) countEl.textContent = `${total}/${this.maxSlots}`;
        
        if (nextEl) {
          const nextTier = this.tiers.find(t => t.qty > total);
          if (nextTier) {
            const needed = nextTier.qty - total;
            nextEl.textContent = `noch ${needed} bis −${nextTier.off}%`;
          } else {
            const currentTier = this.tiers.find(t => total >= t.qty);
            if (currentTier) {
              nextEl.textContent = `−${currentTier.off}% erreicht`;
            } else {
              nextEl.textContent = 'noch 3 bis −10%';
            }
          }
        }
      }
      
      /**
       * Commit changes (to be implemented per sheet type)
       */
      commit() {
        this.onCommit(this.sheetItems);
      }
    }
    
    function initGlobalBottomSheet() {
      const sheet = document.getElementById('bb-sheet-global');
      if (!sheet) return;
      
      const scrim = document.getElementById('bb-scrim-global');
      const grid = document.getElementById('bb-sheet-global-grid');
      // Unterstützt beide Varianten (mit/ohne -global) für SSOT
      const milestonesContainer = sheet.querySelector('[data-bb-milestones], [data-bb-milestones-global]');
      const closeBtn = sheet.querySelector('[data-bb-close], [data-bb-close-global]');
      const resetBtn = sheet.querySelector('[data-bb-reset], [data-bb-reset-global]');
      const commitBtn = sheet.querySelector('[data-bb-commit], [data-bb-commit-global]');
      const panel = sheet.querySelector('.bb-sheet__panel');
      
      if (!grid) return;
      
      let sheetOpen = false;
      let sheetItems = {};
      let currentProductId = null;
      let currentTiers = [];
      
      // Helper: Get Tier for Quantity
      function getTierForQty(qty, tiers) {
        if (!tiers || tiers.length === 0) return null;
        let bestTier = null;
        for (let i = tiers.length - 1; i >= 0; i--) {
          if (qty >= tiers[i].qty) {
            bestTier = tiers[i];
            break;
          }
        }
        return bestTier;
      }
      
      // Helper: Create Variant Tile (EXAKT wie Liquid-Snippet)
      function createVariantTile(variant, product) {
        const tile = document.createElement('div');
        tile.className = 'bb-tile';
        if (!variant.available) tile.classList.add('is-disabled');
        tile.setAttribute('data-variant-id', variant.id);
        tile.setAttribute('data-qty', '0');
        tile.setAttribute('role', 'listitem');
        
        // Image Wrap (exakt wie Liquid)
        const imgWrap = document.createElement('div');
        imgWrap.className = 'bb-tile__imgwrap';
        
        // Nutze normalizeImageUrl für robuste Bild-Extraktion
        const imgSrc = normalizeImageUrl(variant, product);
        if (imgSrc) {
          const img = document.createElement('img');
          img.src = imgSrc;
          img.alt = variant.title || '';
          img.loading = 'lazy';
          img.decoding = 'async';
          imgWrap.appendChild(img);
        }
        
        // Info Container (exakt wie Liquid - KEINE details/title/price)
        const info = document.createElement('div');
        info.className = 'bb-tile__info';
        
        // Add Button (exakt wie Liquid)
        const addBtn = document.createElement('button');
        addBtn.className = 'bb-btn-add';
        addBtn.type = 'button';
        addBtn.setAttribute('aria-label', 'Hinzufügen');
        addBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>';
        
        // Stepper (exakt wie Liquid)
        const stepper = document.createElement('div');
        stepper.className = 'bb-stepper';
        stepper.setAttribute('aria-label', 'Menge anpassen');
        stepper.style.display = 'none';
        
        const minusBtn = document.createElement('button');
        minusBtn.className = 'bb-stepper__btn bb-stepper__minus';
        minusBtn.type = 'button';
        minusBtn.setAttribute('data-bb-minus', '');
        minusBtn.setAttribute('aria-label', 'Weniger');
        minusBtn.textContent = '−';
        
        const qtyOutput = document.createElement('output');
        qtyOutput.className = 'bb-stepper__qty';
        qtyOutput.setAttribute('data-bb-qty', '');
        qtyOutput.textContent = '0';
        
        const plusBtn = document.createElement('button');
        plusBtn.className = 'bb-stepper__btn bb-stepper__plus';
        plusBtn.type = 'button';
        plusBtn.setAttribute('data-bb-plus', '');
        plusBtn.setAttribute('aria-label', 'Mehr');
        plusBtn.textContent = '+';
        
        stepper.appendChild(minusBtn);
        stepper.appendChild(qtyOutput);
        stepper.appendChild(plusBtn);
        
        // Struktur exakt wie Liquid: info enthält nur addBtn und stepper
        info.appendChild(addBtn);
        info.appendChild(stepper);
        
        // Struktur exakt wie Liquid: tile enthält imgWrap und info
        tile.appendChild(imgWrap);
        tile.appendChild(info);
        
        return tile;
      }
      
      // Helper: Format Money
      function formatMoney(cents) {
        const format = window.Shopify?.format?.money || ((c) => (c / 100).toFixed(2) + ' €');
        return typeof format === 'function' ? format(cents) : (cents / 100).toFixed(2) + ' €';
      }
      
      // Open Sheet
      function openSheet() {
        if (sheetOpen || !sheet) return;
        
        sheet.removeAttribute('hidden');
        if (scrim) scrim.removeAttribute('hidden');
        
        sheet.classList.add('is-open');
        sheetOpen = true;
        document.documentElement.classList.add('bb--sheet-open');
        document.body.style.overflow = 'hidden';
        
        panel?.setAttribute('tabindex', '-1');
        panel?.focus({ preventScroll: true });
      }
      
      // Close Sheet
      function closeSheet() {
        if (!sheetOpen || !sheet) return;
        
        sheet.classList.remove('is-open');
        sheet.setAttribute('hidden', '');
        if (scrim) scrim.setAttribute('hidden', '');
        sheetOpen = false;
        document.documentElement.classList.remove('bb--sheet-open');
        document.body.style.overflow = '';
      }
      
      // Update Quantities (vereinheitlicht mit mobile_updateSheetQuantities)
      function updateQuantities() {
        grid.querySelectorAll('.bb-tile').forEach(tile => {
          const vid = String(tile.dataset.variantId);
          const qty = sheetItems[vid] || 0;
          
          // Update data-qty attribute
          tile.setAttribute('data-qty', String(qty));
          
          const qtyOutput = tile.querySelector('[data-bb-qty]');
          const addBtn = tile.querySelector('.bb-btn-add');
          const stepper = tile.querySelector('.bb-stepper');
          
          if (qty === 0) {
            // Initial-Zustand: Keine "0" anzeigen, nur Add-Button sichtbar
            if (qtyOutput) qtyOutput.textContent = '';
            if (addBtn) {
              addBtn.style.display = '';
              addBtn.removeAttribute('hidden');
            }
            if (stepper) {
              stepper.style.display = 'none';
              stepper.setAttribute('hidden', '');
            }
          } else {
            // qty > 0: Menge anzeigen, Stepper sichtbar, Add-Button versteckt
            if (qtyOutput) qtyOutput.textContent = String(qty);
            if (addBtn) {
              addBtn.style.display = 'none';
              addBtn.setAttribute('hidden', '');
            }
            if (stepper) {
              stepper.style.display = 'flex';
              stepper.removeAttribute('hidden');
            }
          }
        });
        
        updateMilestones();
      }
      
      // Update Milestones
      function updateMilestones() {
        const total = Object.values(sheetItems).reduce((a, b) => a + b, 0);
        const tier = getTierForQty(total, currentTiers);
        
        milestonesContainer?.querySelectorAll('.bb-chip').forEach(chip => {
          const m = parseInt(chip.dataset.m || '0', 10);
          if (m === 0) {
            chip.classList.toggle('is-active', total === 0);
          } else {
            chip.classList.toggle('is-active', tier && tier.qty === m);
          }
        });
        
        // Unterstützt beide Varianten (mit/ohne -global) für SSOT
        const countEl = sheet.querySelector('[data-bb-sheet-count], [data-bb-sheet-count-global]');
        const nextEl = sheet.querySelector('[data-bb-sheet-next], [data-bb-sheet-next-global]');
        
        if (countEl) countEl.textContent = `${total}/10`;
        
        if (nextEl && tier) {
          const nextTier = currentTiers.find(t => t.qty > total);
          if (nextTier) {
            const needed = nextTier.qty - total;
            nextEl.textContent = `noch ${needed} bis −${nextTier.off}%`;
          } else {
            nextEl.textContent = `−${tier.off}% erreicht`;
          }
        }
      }
      
      // Helper: Populate Sheet with Product Data
      function populateSheetWithProduct(product) {
        currentProductId = product.id;
        
        // Get Tiers (defensives Parsing)
        const defaultTiers = [{qty:3,off:10},{qty:6,off:20},{qty:10,off:25}];
        let tiers = defaultTiers;
        if (product.tiers) {
          try {
            tiers = typeof product.tiers === 'string' 
              ? JSON.parse(product.tiers)
              : product.tiers;
            // Validiere dass es ein Array ist
            if (!Array.isArray(tiers)) {
              tiers = defaultTiers;
            }
          } catch(e) {
            console.warn('[Bundle Builder] Failed to parse tiers, using default', e);
            tiers = defaultTiers;
          }
        }
        currentTiers = tiers;
        
        // Populate Milestones
        if (milestonesContainer) {
          milestonesContainer.innerHTML = '<span class="bb-chip" data-m="0">0%</span>';
          tiers.forEach(t => {
            const chip = document.createElement('span');
            chip.className = 'bb-chip';
            chip.setAttribute('data-m', t.qty);
            chip.textContent = `−${t.off}%`;
            milestonesContainer.appendChild(chip);
          });
        }
        
        // Populate Grid
        grid.innerHTML = '';
        if (product.variants && Array.isArray(product.variants)) {
          product.variants.forEach(variant => {
            const tile = createVariantTile({
              id: variant.id,
              title: variant.title,
              price: variant.price,
              available: variant.available,
              image: variant.image || ''
            }, product);
            grid.appendChild(tile);
          });
        }
        
        sheetItems = {};
        updateQuantities();
        openSheet();
      }
      
      // Load Product and Open Sheet (SSOT: Template-First Approach - 1:1 Original-PDP-Markup)
      // FIXED: Akzeptiert jetzt explizit beide Parameter (productId und productHandle)
      async function loadProductAndOpenSheet(productId, productHandle) {
        // Defensive: Unterstützung für Legacy-Aufrufe mit nur einem Parameter
        if (productHandle === undefined && productId !== undefined) {
          // Versuche zu erraten, ob productId ein Handle oder eine ID ist
          const isHandle = typeof productId === 'string' && !/^\d+$/.test(productId);
          if (isHandle) {
            productHandle = productId;
            productId = null;
          }
        }
        
        try {
          // PRIORITY 1: Vollständiges Sheet-HTML Template (1:1 Original-PDP-Markup)
          if (productId) {
            const sheetTemplate = document.getElementById(`bb-sheet-template-${productId}`);
            if (sheetTemplate) {
              console.log('[Bundle Builder] Using sheet template (1:1 Original-PDP-Markup) for product:', productId);
              
              // Klone Template-Inhalt
              const clonedContent = sheetTemplate.content.cloneNode(true);
              
              // Finde das Panel im globalen Sheet und ersetze es
              const globalSheet = document.getElementById('bb-sheet-global');
              if (globalSheet) {
                const existingPanel = globalSheet.querySelector('.bb-sheet__panel');
                if (existingPanel) {
                  // Ersetze das Panel komplett mit geklontem Inhalt
                  const newPanel = clonedContent.querySelector('.bb-sheet__panel') || clonedContent.firstElementChild;
                  if (newPanel) {
                    existingPanel.replaceWith(newPanel);
                    
                    // Reset Event-Handler Flag, damit Event-Handler neu angehängt werden können
                    // (Event-Delegation funktioniert auch ohne, aber für Sicherheit)
                    if (globalSheet.dataset.bbGlobalHandlersAttached === 'true') {
                      delete globalSheet.dataset.bbGlobalHandlersAttached;
                    }
                    
                    // Re-Initialisiere Event-Listener (da DOM neu ist)
                    // initGlobalBottomSheet() muss neu laufen, um Event-Listener zu binden
                    initGlobalBottomSheet();
                    
                    // Warte kurz, damit initGlobalBottomSheet() fertig ist und Event-Listener gebunden sind
                    await new Promise(resolve => setTimeout(resolve, 100));
                    
                    // Öffne Sheet direkt (ohne loadProductAndOpenSheet erneut aufzurufen)
                    const sheet = document.getElementById('bb-sheet-global');
                    const scrim = document.getElementById('bb-scrim-global');
                    if (sheet) {
                      sheet.removeAttribute('hidden');
                      if (scrim) scrim.removeAttribute('hidden');
                      sheet.classList.add('is-open');
                      document.documentElement.classList.add('bb--sheet-open');
                      document.body.style.overflow = 'hidden';
                      
                      const panel = sheet.querySelector('.bb-sheet__panel');
                      if (panel) {
                        panel.setAttribute('tabindex', '-1');
                        requestAnimationFrame(() => {
                          panel.focus({ preventScroll: true });
                        });
                      }
                    }
                    
                    // State aus Cart laden und UI aktualisieren (falls Bundle vorhanden)
                    // Initial-Zustand (alle qty = 0) - wird durch Stepper-Delegation aktualisiert
                    return;
                  }
                }
              }
            }
          }
          
          // PRIORITY 2: JSON-Daten Template (Fallback für dynamische Befüllung)
          if (productId) {
            const template = document.getElementById(`bb-payload-${productId}`);
            if (template) {
              const script = template.querySelector('script[type="application/json"]');
              if (script) {
                try {
                  const product = JSON.parse(script.textContent);
                  console.log('[Bundle Builder] Using JSON template data (fallback) for product:', productId);
                  populateSheetWithProduct(product);
                  return;
                } catch (e) {
                  console.warn('[Bundle Builder] Failed to parse template data, falling back to AJAX', e);
                }
              }
            }
          }
          
          // Fallback: AJAX-Request mit Handle (PRIORITÄT) oder ID
          console.log('[Bundle Builder] Loading product via AJAX:', {
            productHandle: productHandle,
            productId: productId,
            identifier: productHandle || productId,
            source: productHandle ? 'handle' : (productId ? 'id-fallback' : 'none')
          });
          
          // WICHTIG: Shopify unterstützt nur /products/{handle}.js, nicht /products/{id}.js
          if (!productHandle && productId) {
            console.error('[Bundle Builder] CRITICAL: No handle available, cannot fetch product. Product ID:', productId);
            throw new Error('Product handle is required for API call. Handle missing from button data-product-handle attribute.');
          }
          
          if (!productHandle) {
            throw new Error('No product handle provided. Cannot fetch product data.');
          }
          
          let shopifyRoot = '';
          if (window.Shopify?.routes?.root) {
            shopifyRoot = window.Shopify.routes.root;
          } else if (window.Shopify?.routes) {
            shopifyRoot = window.Shopify.routes.root || '';
          }
          if (shopifyRoot && !shopifyRoot.endsWith('/')) {
            shopifyRoot += '/';
          }
          
          // Best Case: Handle verfügbar (erforderlich für Shopify API)
          const productUrl = shopifyRoot + `products/${productHandle}.js`;
          
          const response = await fetch(productUrl);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const product = await response.json();
          
          // Transform AJAX response to match template format
          const defaultTiers = [{qty:3,off:10},{qty:6,off:20},{qty:10,off:25}];
          let tiers = defaultTiers;
          if (product.metafields?.custom?.bundle_tiers?.value) {
            try {
              tiers = typeof product.metafields.custom.bundle_tiers.value === 'string' 
                ? JSON.parse(product.metafields.custom.bundle_tiers.value)
                : product.metafields.custom.bundle_tiers.value;
            } catch(e) {
              tiers = defaultTiers;
            }
          }
          
          const transformedProduct = {
            id: product.id,
            title: product.title,
            handle: product.handle,
            variants: product.variants.map(v => ({
              id: v.id,
              title: v.title,
              price: v.price,
              available: v.available,
              image: v.featured_image?.src || product.featured_image?.src || ''
            })),
            tiers: tiers
          };
          
          populateSheetWithProduct(transformedProduct);
          
        } catch (error) {
          console.error('[Global Bundle Builder] Error loading product:', error);
          alert('Fehler beim Laden der Produktdaten: ' + (error.message || 'Unbekannter Fehler') + '. Bitte versuchen Sie es erneut.');
        }
      }
      
      // SSOT: Event-Delegation auf sheet-Ebene für alle Interaktionen (funktioniert auch nach DOM-Änderungen)
      // WICHTIG: Delegation auf sheet statt einzelne Buttons/grid, damit es auch nach Template-Ersetzung funktioniert
      if (sheet) {
        // Verhindere mehrfache Anhängung
        if (!sheet.dataset.bbGlobalHandlersAttached) {
          sheet.dataset.bbGlobalHandlersAttached = 'true';
          
          // Event-Delegation für alle Interaktionen
          sheet.addEventListener('click', (e) => {
            // Close Button (unterstützt beide Varianten)
            const closeBtn = e.target.closest('[data-bb-close], [data-bb-close-global]');
            if (closeBtn) {
              e.preventDefault();
              e.stopPropagation();
              closeSheet();
              return;
            }
            
            // Reset Button (unterstützt beide Varianten)
            const resetBtn = e.target.closest('[data-bb-reset], [data-bb-reset-global]');
            if (resetBtn) {
              e.preventDefault();
              e.stopPropagation();
              sheetItems = {};
              updateQuantities();
              return;
            }
            
            // Commit Button (unterstützt beide Varianten)
            const commitBtn = e.target.closest('[data-bb-commit], [data-bb-commit-global]');
            if (commitBtn) {
              e.preventDefault();
              e.stopPropagation();
              handleGlobalCommit();
              return;
            }
            
            // Add-Button Handler (öffnet Stepper)
            const addBtn = e.target.closest('.bb-btn-add');
            if (addBtn) {
              const tile = addBtn.closest('.bb-tile');
              if (tile) {
                const plusBtn = tile.querySelector('[data-bb-plus]');
                if (plusBtn) {
                  plusBtn.click();
                  return;
                }
              }
            }
            
            // Plus/Minus Handler (Stepper)
            const plus = e.target.closest('[data-bb-plus]');
            const minus = e.target.closest('[data-bb-minus]');
            if (plus || minus) {
              const tile = e.target.closest('.bb-tile');
              if (!tile) return;
              const vid = String(tile.dataset.variantId);
              
              const cur = sheetItems[vid] || 0;
              const total = Object.values(sheetItems).reduce((a, b) => a + b, 0);
              
              if (plus) {
                if (total < 10) sheetItems[vid] = cur + 1;
              } else {
                if (cur <= 1) delete sheetItems[vid];
                else sheetItems[vid] = cur - 1;
              }
              
              updateQuantities();
              return;
            }
            
            // Sheet-Backdrop Click
            if (e.target === sheet) {
              closeSheet();
              return;
            }
          });
        }
      }
      
      // Scrim Click Handler
      if (scrim) {
        scrim.addEventListener('click', (e) => {
          e.preventDefault();
          closeSheet();
        });
      }
      
      // ESC Key Handler (global, prüft ob global sheet offen ist)
      const escHandler = (e) => {
        if (e.key === 'Escape' && sheetOpen && sheet.classList.contains('is-open')) {
          closeSheet();
        }
      };
      document.addEventListener('keydown', escHandler);
      
      // Cleanup-Funktion für spätere Verwendung
      sheet._bbEscHandler = escHandler;
      
      // Commit Handler - separate Funktion für bessere Lesbarkeit
      async function handleGlobalCommit() {
        if (Object.keys(sheetItems).length === 0) {
          alert('Bitte wählen Sie mindestens einen Booster aus.');
          return;
        }
        
        const items = Object.entries(sheetItems).map(([vid, qty]) => ({
          id: parseInt(vid, 10),
          quantity: qty
        }));
        
        try {
          const cartRoute = window.Shopify?.routes?.root 
            ? window.Shopify.routes.root + 'cart/add.js'
            : '/cart/add.js';
          const response = await fetch(cartRoute, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ items: items })
          });
          
          if (!response.ok) {
            const error = await response.json();
            throw new Error(error.description || 'Fehler beim Hinzufügen zum Warenkorb');
          }
          
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            const sectionsRoute = window.Shopify?.routes?.root
              ? window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble'
              : '/?sections=cart-drawer,cart-icon-bubble';
            fetch(sectionsRoute)
              .then(r => r.json())
              .then(sections => {
                if (cartDrawer.renderContents) {
                  cartDrawer.renderContents(sections);
                }
              });
          } else {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          }
          
          closeSheet();
          
          if (cartDrawer) {
            setTimeout(() => {
              if (typeof cartDrawer.open === 'function') {
                cartDrawer.open();
              } else {
                document.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
              }
            }, 300);
          }
          
        } catch (error) {
          console.error('[Global Bundle Builder] Error adding to cart:', error);
          alert(error.message || 'Fehler beim Hinzufügen zum Warenkorb');
        }
      }
      
      // Expose function globally
      // FIXED: Wrapper-Funktion, die beide Parameter (ID und Handle) übergibt
      window.openGlobalBottomSheet = function(productId, productHandle) {
        // Wenn nur ein Parameter übergeben wird (Legacy), versuche zu erraten
        if (productHandle === undefined && productId !== undefined) {
          // Prüfe ob productId ein Handle ist (String, keine reine Zahl)
          const isHandle = typeof productId === 'string' && !/^\d+$/.test(productId);
          if (isHandle) {
            productHandle = productId;
            productId = null;
          }
        }
        // Rufe loadProductAndOpenSheet mit beiden Parametern auf
        return loadProductAndOpenSheet(productId, productHandle);
      };
      
      console.log('[Bundle Builder] Global bottom sheet initialized, window.openGlobalBottomSheet available');
    }
    
    // Defensive: Stelle sicher, dass Funktionen immer existieren (SOFORT, vor Initialisierung)
    // Diese Funktionen werden sofort gesetzt, bevor initGlobalBottomSheet() läuft
    (function() {
      'use strict';
      
      if (!window.openGlobalBottomSheet) {
        const fallbackFn = function(productId) {
          console.warn('[Bundle Builder] openGlobalBottomSheet called before initialization, initializing now...');
          // Fallback: Initialisiere jetzt
          if (typeof initGlobalBottomSheet === 'function') {
            initGlobalBottomSheet();
          } else if (typeof initGlobalBundleBuilder === 'function') {
            initGlobalBundleBuilder();
          }
          // Retry nach kurzer Verzögerung
          setTimeout(() => {
            if (window.openGlobalBottomSheet && window.openGlobalBottomSheet !== fallbackFn) {
              window.openGlobalBottomSheet(productId);
            } else {
              console.error('[Bundle Builder] Failed to initialize after retry');
              alert('Fehler: Bottom Sheet konnte nicht initialisiert werden. Bitte Seite neu laden.');
            }
          }, 100);
        };
        window.openGlobalBottomSheet = fallbackFn;
      }
      
      if (!window.openDesktopModal) {
        const fallbackModalFn = function(productId, tiers) {
          console.warn('[Bundle Builder] openDesktopModal called before initialization, initializing now...');
          // Fallback: Initialisiere jetzt
          if (typeof initGlobalModal === 'function') {
            initGlobalModal();
          } else if (typeof initGlobalBundleBuilder === 'function') {
            initGlobalBundleBuilder();
          }
          // Retry nach kurzer Verzögerung
          setTimeout(() => {
            if (window.openDesktopModal && window.openDesktopModal !== fallbackModalFn) {
              if (tiers) {
                window.openDesktopModal(productId, tiers);
              } else {
                window.openDesktopModal(productId);
              }
            } else {
              console.error('[Bundle Builder] Failed to initialize modal after retry');
              alert('Fehler: Modal konnte nicht initialisiert werden. Bitte Seite neu laden.');
            }
          }, 100);
        };
        window.openDesktopModal = fallbackModalFn;
      }
    })();
    
    function initGlobalModal() {
      // Unterstützt sowohl #bb-modal als auch #bb-modal-global
      const modal = document.getElementById('bb-modal-global') || document.getElementById('bb-modal');
      if (!modal) return;
      
      // Initialisierung wird von initDesktopModal() übernommen, falls #bb-modal existiert
      // Für #bb-modal-global wird window.openDesktopModal verwendet (bereits implementiert)
    }
    
    function handleGlobalTrigger(e) {
      // this ist der Trigger (durch call() gebunden bei Event-Delegation)
      const trigger = this || e.currentTarget;
      const triggerType = trigger.dataset.bbTrigger; // 'sheet', 'modal', oder 'true'
      const productId = trigger.dataset.productId;
      const productHandle = trigger.dataset.productHandle; // NEU: Handle auslesen
      
      console.log('[Bundle Builder] Global trigger handler called', {
        triggerType,
        productId,
        productHandle, // NEU
        isMobile: window.innerWidth <= 989,
        hasOpenGlobalBottomSheet: !!window.openGlobalBottomSheet,
        hasOpenDesktopModal: !!window.openDesktopModal
      });
      
      if (!productId && !productHandle) {
        console.error('[Global Bundle Builder] No product ID or handle found on trigger', trigger);
        return;
      }
      
      // Warnung wenn Handle fehlt aber ID vorhanden ist (defensive)
      if (!productHandle && productId) {
        console.warn('[Bundle Builder] Handle missing, using ID fallback. This may cause 404 errors. Product ID:', productId);
      }
      
      const isMobile = window.innerWidth <= 989;
      
      // PRIORITY: Trigger-Type hat Vorrang, dann Mobile/Desktop-Weiche
      if (triggerType === 'sheet' || (isMobile && !triggerType)) {
        // Mobile: Bottom Sheet
        if (window.openGlobalBottomSheet) {
          // FIXED: Übergebe beide Werte (ID für Template-Lookup, Handle für API)
          window.openGlobalBottomSheet(productId, productHandle);
        } else {
          // Defensive Fallback
          console.error('[Bundle Builder] window.openGlobalBottomSheet not available, initializing...');
          if (typeof initGlobalBottomSheet === 'function') {
            initGlobalBottomSheet();
            setTimeout(() => {
              if (window.openGlobalBottomSheet) {
                // FIXED: Übergebe beide Werte
                window.openGlobalBottomSheet(productId, productHandle);
              } else {
                alert('Fehler: Bottom Sheet konnte nicht initialisiert werden.');
              }
            }, 100);
          } else {
            alert('Fehler: Bottom Sheet konnte nicht initialisiert werden.');
          }
        }
      } else if (triggerType === 'modal' || (!isMobile && triggerType === 'true')) {
        // Desktop: Modal
        if (window.openDesktopModal || typeof loadProductForModal === 'function') {
          // Übergebe Handle (mit ID-Fallback)
          loadProductForModal(productHandle || productId).then(({variants, tiers, product}) => {
            if (window.openDesktopModal) {
              window.openDesktopModal(variants, tiers, product);
            } else {
              console.error('[Bundle Builder] window.openDesktopModal not available');
              alert('Fehler: Modal konnte nicht geöffnet werden.');
            }
          }).catch(error => {
            console.error('[Global Bundle Builder] Error loading product for modal:', error);
            alert('Fehler beim Laden der Produktdaten.');
          });
        } else {
          console.error('[Bundle Builder] Modal functions not available');
          alert('Fehler: Modal konnte nicht geöffnet werden.');
        }
      }
    }
    
    async function loadProductForModal(productIdentifier) {
      // productIdentifier kann Handle (String) oder ID (Number) sein
      // Prüfe ob es ein Handle (String ohne nur Zahlen) oder ID (nur Zahlen) ist
      const isHandle = typeof productIdentifier === 'string' && !/^\d+$/.test(productIdentifier);
      const productHandle = isHandle ? productIdentifier : null;
      const productId = isHandle ? null : productIdentifier;
      
      // SSOT: Prüfe zuerst Template-Tag (Performance) - nutze ID für Template-Lookup
      if (productId) {
        const template = document.getElementById(`bb-payload-${productId}`);
        if (template) {
          const script = template.querySelector('script[type="application/json"]');
          if (script) {
            try {
              const product = JSON.parse(script.textContent);
              console.log('[Bundle Builder] Using template tag data for modal product:', productId);
              const variants = product.variants.map(v => ({
                id: v.id,
                title: v.title,
                price: v.price,
                available: v.available,
                // Nutze Image Normalizer für konsistente Bild-URLs
                image: normalizeImageUrl(v, product),
                // Behalte Original-Daten für Fallback
                featured_image: v.featured_image || product.featured_image || null
              }));
              
              const defaultTiers = [{qty:3,off:10},{qty:6,off:20},{qty:10,off:25}];
              let tiers = defaultTiers;
              if (product.tiers) {
                try {
                  tiers = typeof product.tiers === 'string' 
                    ? JSON.parse(product.tiers)
                    : product.tiers;
                  if (!Array.isArray(tiers)) {
                    tiers = defaultTiers;
                  }
                } catch(e) {
                  tiers = defaultTiers;
                }
              }
              
              return { variants, tiers, product };
            } catch (e) {
              console.warn('[Bundle Builder] Failed to parse template data for modal, falling back to AJAX', e);
            }
          }
        }
      }
      
      // Fallback: AJAX-Request mit Handle (wenn verfügbar) oder ID
      console.log('[Bundle Builder] Loading product for modal via AJAX:', productHandle || productId);
      let shopifyRoot = '';
      if (window.Shopify?.routes?.root) {
        shopifyRoot = window.Shopify.routes.root;
      } else if (window.Shopify?.routes) {
        shopifyRoot = window.Shopify.routes.root || '';
      }
      if (shopifyRoot && !shopifyRoot.endsWith('/')) {
        shopifyRoot += '/';
      }
      
      // WICHTIG: Shopify unterstützt nur /products/{handle}.js, nicht /products/{id}.js
      let productUrl;
      if (productHandle) {
        // Best Case: Handle verfügbar
        productUrl = shopifyRoot + `products/${productHandle}.js`;
      } else if (productId) {
        // Fallback: Versuche ID (wird wahrscheinlich 404 geben, aber versuchen wir es)
        console.warn('[Bundle Builder] No handle available, using ID (may fail):', productId);
        productUrl = shopifyRoot + `products/${productId}.js`;
      } else {
        throw new Error('No product identifier (handle or ID) provided');
      }
      
      const response = await fetch(productUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const product = await response.json();
      
      const variants = product.variants.map(v => ({
        id: v.id,
        title: v.title,
        price: v.price,
        available: v.available,
        // Nutze Image Normalizer für konsistente Bild-URLs
        image: normalizeImageUrl(v, product),
        // Behalte Original-Daten für Fallback
        featured_image: v.featured_image || product.featured_image || null
      }));
      
      const defaultTiers = [{qty:3,off:10},{qty:6,off:20},{qty:10,off:25}];
      let tiers = defaultTiers;
      if (product.metafields?.custom?.bundle_tiers?.value) {
        try {
          tiers = typeof product.metafields.custom.bundle_tiers.value === 'string' 
            ? JSON.parse(product.metafields.custom.bundle_tiers.value)
            : product.metafields.custom.bundle_tiers.value;
        } catch(e) {
          tiers = defaultTiers;
        }
      }
      
      return { variants, tiers, product };
    }
    
    function handleLegacyTrigger(e) {
      // Für Rückwärtskompatibilität: Konvertiere Legacy-Trigger zu globalem Format
      // this ist der Trigger (durch call() gebunden)
      const trigger = this || e.currentTarget;
      const productId = trigger.dataset.productId;
      const productHandle = trigger.dataset.productHandle; // FIXED: Handle explizit extrahieren
      
      console.log('[Bundle Builder] Legacy trigger clicked', {
        productId,
        productHandle, // FIXED: Handle im Log
        hasDataOpenMobileSheet: trigger.hasAttribute('data-open-mobile-sheet'),
        hasDataOneClick: trigger.hasAttribute('data-one-click'),
        isMobile: window.innerWidth <= 989
      });
      
      if (!productId && !productHandle) {
        console.error('[Bundle Builder] No product ID or handle found on legacy trigger', trigger);
        return;
      }
      
      // Warnung wenn Handle fehlt aber ID vorhanden ist (defensive)
      if (!productHandle && productId) {
        console.warn('[Bundle Builder] Handle missing on legacy trigger, using ID fallback. This may cause 404 errors. Product ID:', productId);
      }
      
      const isMobile = window.innerWidth <= 989;
      
      if (trigger.hasAttribute('data-open-mobile-sheet') || isMobile) {
        // Mobile Bottom Sheet
        // FIXED: Übergebe beide Werte (ID für Template-Lookup, Handle für API)
        if (window.openGlobalBottomSheet) {
          console.log('[Bundle Builder] Opening global bottom sheet (legacy) for product:', productId, 'handle:', productHandle);
          window.openGlobalBottomSheet(productId, productHandle);
        } else {
          console.error('[Bundle Builder] window.openGlobalBottomSheet not available, initializing...');
          initGlobalBottomSheet();
          if (window.openGlobalBottomSheet) {
            window.openGlobalBottomSheet(productId, productHandle);
          }
        }
      } else if (trigger.hasAttribute('data-one-click')) {
        // Desktop Modal
        handleGlobalTrigger.call(trigger, e);
      }
    }
    
    // Initialisiere globale Komponente
    onReady(initGlobalBundleBuilder);
    document.addEventListener('shopify:section:load', initGlobalBundleBuilder);
  })();
  